const TRANSLATION = {
  buyModal: {
    afterFree: 'നിങ്ങളുടെ ഫ്രീ ട്രയലിന് ശേഷം',
    btn: 'തടസ്സമില്ലാതെ പരീക്ഷിക്കുക',
    freeTrial: '3 ദിവസത്തെ ഫ്രീ ട്രയൽ',
    monthLabel: 'മാസം',
    selectLabel: 'ഒരു പ്ലാൻ തിരഞ്ഞെടുക്കുക',
    title: 'സബ്സ്ക്രിപ്ഷൻ പ്ലാൻ',
    yearLabel: 'വർഷം',
  },
  contact: {
    block1:
      'കസ്റ്റമൈസേഷന്, ചോദ്യങ്ങൾ അല്ലെങ്കിൽ നിർദ്ദേശങ്ങൾക്കായി, ദയവായി contact@noam.tools എന്നതിലൂടെ ഞങ്ങളെ ബന്ധപ്പെടുക. ഞങ്ങൾ ഉടൻ പ്രതികരിക്കും.',
    block2: 'ഗൂഗിൾ ആപ്സ് എക്സ്റ്റൻഷൻ സ്റ്റോറിൽ ഞങ്ങളെ ★★★★★ എന്ന റേറ്റിംഗ് നൽകി പിന്തുണയ്ക്കുക.',
    block3: 'ഈ എക്സ്റ്റൻഷൻ പങ്കിട്ട് മറ്റുള്ളവരെ സഹായിക്കുക:',
    title: 'ഞങ്ങളെ ബന്ധപ്പെടുക',
  },
  help: {
    AquickOverviewOfNoam: 'നോം അവലോകനം',
    ChatPDF: 'ചാറ്റ് പിഡിഎഫ്',
    ChatPDF2: 'ചാറ്റ് പിഡിഎഫ്',
    FavoritesManagement: 'പ്രിയപ്പെട്ട വസ്തുക്കളുടെ മാനേജ്മെന്റ്',
    Fixedplugin: 'പ്ലഗിൻ സ്ഥിരീകരിച്ചു',
    Focusing: 'കേന്ദ്രീകരിക്കുക',
    Free: 'വിഗതം',
    FreeTrialBenefits: 'ഫ്രീ ട്രയൽ ഗുണങ്ങൾ',
    GoWithWikipedia: 'വിക്കിപീഡിയയോടൊപ്പം പോകുക',
    GoWithYouTube: 'യൂട്യൂബോടൊപ്പം പോകുക',
    HoverTranslation: 'ഹോവർ വിവർത്തനം',
    Howtouse: 'ഇതിനെ എങ്ങനെ ഉപയോഗിക്കാം',
    ImageTranslation: 'ചിത്ര വിവർത്തനം',
    InstantTranslation: 'ഇൻസ്റ്റന്റ് വിവർത്തനം',
    Membership: 'അംഗത്വം',
    NoamHelp: 'നോം നിങ്ങളെ വിവർത്തനം ചെയ്യാനും സംഗ്രഹിക്കാനും സഹായിക്കുന്നു',
    PDFparallelTranslation: 'പിഡിഎഫ് പാരല lel ട്രാൻസ്ലേഷൻ',
    ParallelTranslation: 'പാരല lel മொழிபெயர്ക്കൽ',
    SkipAllSteps: 'എല്ലാ ഘട്ടങ്ങളും സ്കിപ്പ് ചെയ്യുക',
    Summary: 'സംഗ്രഹം',
    Translation: 'വിവർത്തനം',
    TryItForFree: 'തട്ടി നോക്കുക, സൗജന്യമായി',
    Video: 'വീഡിയോ',
    VideoSummary: 'വീഡിയോ സംഗ്രഹം',
    VideoTranslation: 'വീഡിയോ വിവർത്തനം',
    WebSummary: 'വെബ് സംഗ്രഹം',
    WordSelectionTranslation: 'വാക്ക് തിരഞ്ഞെടുക്കൽ വിവർത്തനം',
    benefits: 'നിങ്ങൾക്കായി പ്രതീക്ഷിക്കുന്ന നേട്ടങ്ങൾ ഞങ്ങൾക്ക് ഉണ്ട്!',
    dayFree: '3 ദിവസത്തെ ഫ്രീ ട്രയൽ',
    done: 'സമാപിച്ചു',
    next: 'അടുത്തത്',
    pin: 'എളുപ്പത്തിൽ ആക്സസ് ചെയ്യാൻ നോം പിൻ ചെയ്യുക～～',
    planIsNotExist: 'പ്ലാൻ ലഭ്യമല്ല',
    startWiki: 'വിക്കിമീഡിയയുമായി ആരംഭിക്കാം!',
    startYoutube: 'യൂട്യൂബ് മായി ആരംഭിക്കാം!',
    try: 'ഇത് പരീക്ഷിക്കുക',
    tryNow: 'ഇപ്പോൾ ശ്രമിക്കുക!',
  },
  home: {
    PDFTranslate: {
      desc: 'ദ്വീഭാഷാ വിവർത്തനം + ചാറ്റ് പിഡിഎഫ്',
      sub1: {
        desc: 'ദ്വീഭാഷാ വായനയിലൂടെ നിങ്ങൾക്ക് അസਲ് ടെക്സ്റ്റും വിവർത്തനവും സൈഡ്-ബൈ-സൈഡ് താരതമ്യം ചെയ്യാൻ കഴിയും, ഇത് വായനാ കാര്യക്ഷമത വർദ്ധിപ്പിക്കുന്നു.',
        title: 'ദ്വിഭാഷാ വായന',
      },
      sub2: {
        desc: 'AI വിശകലനം ചെയ്യുകയും സംഗ്രഹിക്കുകയും ചെയ്യുന്നു, കൂടാതെ PDF ഉള്ളടക്കത്തെ അടിസ്ഥാനമാക്കി നിങ്ങളുടെ ചോദ്യങ്ങൾക്ക് ഉത്തരം നൽകാൻ കഴിയും. ',
        title: 'ചാറ്റ് പിഡിഎഫ്',
      },
      sub3: {
        desc: 'മികച്ച കൃത്യതയ്ക്കും കാര്യക്ഷമതೆಗ്കും വേണ്ടി AI-പ്രവർത്തിപ്പിക്കുന്ന PDF വിവർത്തനം.',
        title: 'അക്ക്യുറസി ആൻഡ് എഫിഷ്യൻസി',
      },
      title: 'പിഡിഎഫ് വിവർത്തനം',
    },
    aiAssistant: {
      desc: 'വെബ് വിവർത്തനത്തെ കൂടുതൽ സ്മാർട്ടും സുഖകരവുമാക്കുക',
      panel1: {
        desc: 'ദ്വिभാഷാ ക്രോസ്-റഫറൻസിംഗ് വിവർത്തനങ്ങൾ യഥാർത്ഥ വാചകത്തെ വിവർത്തനവുമായി താരതമ്യം ചെയ്യാൻ സഹായിക്കുന്നു, അതിലൂടെ നിങ്ങൾക്ക് കൂടുതൽ നന്നായി മനസ്സിലാക്കാനും വായനാ കാര്യക്ഷമത വർദ്ധിപ്പിക്കാനും കഴിയും. ',
        title: 'ദ്വീഭാഷാ വിവർത്തനം',
      },
      panel2: {
        left: {
          desc: 'ഒരു വെബ് പേജ് ബ്രൗസ് ചെയ്യുമ്പോൾ, വിവർത്തനം കാണാൻ നിങ്ങൾ വിവർത്തനം ചെയ്യേണ്ട ഉള്ളടക്കത്തിന് മുകളിൽ ഹോവർ ചെയ്യുക.',
          title: 'ഹോവർ വിവർത്തനം',
        },
        right: {
          desc: 'ഒരു വെബ് പേജ് ബ്രൌസ് ചെയ്യുമ്പോൾ, വിവർത്തനം കാണാൻ നിങ്ങൾ വിവർത്തനം ചെയ്യാൻ ആഗ്രഹിക്കുന്ന വാചകത്തെ തിരഞ്ഞെടുക്കുക.',
          title: 'ടെക്സ്റ്റ് സെലക്ഷൻ വിവർത്തനം',
        },
      },
      panel3: {
        one: {
          desc: 'കൂടുതൽ സുഗമമായ അനുഭവത്തിനായി എപ്പോൾ, എവിടെ വേണമെങ്കിലും വെബ് പേജുകളും വീഡിയോ ഉള്ളടക്കങ്ങളും വിവർത്തനം ചെയ്യുകയും സംഗ്രഹിക്കുകയും ചെയ്യുക!',
          title: 'പോയിന്റ് ആൻഡ് ക്ലിക്ക്',
        },
        three: {
          desc: 'AI-നി നയിച്ച വലിയ ഭാഷാ മോഡൽ മെച്ചപ്പെട്ട വായന അനുഭവത്തിനായി വിവർത്തന കൃത്യതയും സ്ഥിരതയും ഉറപ്പുനൽകുന്നു.',
          title: 'AI-നയിത',
        },
        two: {
          desc: 'ബഹുഭാഷാ പൂർണ്ണ കവറേജ്, ദ്വിഭാഷാ ബാരിയർ ഫ്രീ റീഡിംഗ്, ഒറ്റ ക്ലിക്ക് വിവർത്തനം - വ്യത്യാസം അനുഭവിക്കുക!',
          title: 'കൂടുതൽ സമഗ്രമായും സങ്കീർണ്ണവും',
        },
      },
      panel4: {
        tab1: {
          desc: 'നിങ്ങളുടെ കാര്യക്ഷമതാ വിദഗ്ധൻ - ChatGPT ഉപയോഗിച്ച്, നോം YouTube വീഡിയോ ഉള്ളടക്കത്തെ വിവർത്തനം ചെയ്യുകയും സംഗ്രഹിക്കുകയും ചെയ്യുന്നു, ഇത് നിങ്ങളുടെ സമയം ലാഭിക്കുന്നതിനായി!',
          key: 'വീഡിയോ',
          title: 'വീഡിയോ വിവർത്തനം & സംഗ്രഹം',
        },
        tab2: {
          desc: 'വെബ് ബ്രൌസ് ചെയ്യുമ്പോൾ ചിത്രങ്ങൾ വിവർത്തനം ചെയ്യാൻ ക്ലിക്കുചെയ്യുക.',
          key: 'ചിത്രം',
          title: 'ചിത്ര വിവർത്തനം',
        },
        tab3: {
          desc: 'വെബ് പേജുകളിൽ നിന്ന് പ്രധാന വിവരങ്ങൾ തൽക്ഷണം വേർതിരിക്കുകയും സംഗ്രഹം നൽകുകയും ചെയ്യുന്നു, ഇത് നിങ്ങളുടെ വായനാ കാര്യക്ഷമത വർദ്ധിപ്പിക്കുന്നു.',
          key: 'വെബ്',
          title: 'വെബ് ട്രാൻസ്ലേറ്റ് & സംഗ്രഹം',
        },
        tag1: 'സിമ്പിൾ',
        tag2: 'കാര്യക്ഷമമായ',
        tag3: 'എളുപ്പത്തിൽ മനസ്സിലാക്കാവുന്നത്',
      },
      title: 'എഐ അസിസ്റ്റന്‍റ്',
    },
    getStart: ' ആരംഭിക്കുക',
    getStartedForFree: 'സൗജന്യമായി ആരംഭിക്കുക',
    howItWork: {
      desc: 'ക്രോസ്-ലാംഗ്വേജ് വെബ് പേജ് വിവർത്തനത്തിനും സംഗ്രഹത്തിനും, പിഡിഎഫ്, ഇമേജ് വിവർത്തനത്തിനും, വീഡിയോ വിവർത്തനത്തിനും സംഗ്രഹത്തിനും ഉപയോക്താക്കൾക്ക് ബുദ്ധിമാനായ അനുഭവം നൽകുന്നതിനായി നോം AI മോഡലുകളെ സമന്വയിപ്പിക്കുന്നു',
      title: 'ഇത് എങ്ങനെ പ്രവർത്തിക്കുന്നു',
    },
    lastBlock: { desc: 'മങ്ങിയ വായന അനുഭവത്തിനായി മികച്ച AI വിവർത്തനം' },
    top: {
      desc: 'നോം ഒരു സ്വതന്ത്രമായ AI ബ്രൌസർ എക്സ്റ്റൻഷനാണ്, ഇത് വെബ് പേജുകൾ, വീഡിയോകൾ மற்றும் PDF ഉള്ളടക്കങ്ങൾ വിവർത്തനം ചെയ്യാനും സംഗ്രഹിക്കാനും സഹായിക്കുന്നു.\n      നോമിൽ ചേരുക და മാജിക് അനുഭവിക്കുക!',
      title1: 'ഒരു മാജിക്',
      title2: 'ഒരു ക്ലിക്ക്',
    },
    userReviews: { desc: 'ക്രോം വെബ് സ്റ്റോറിലെ അഞ്ച് സ്റ്റാർ റിവ്യൂകൾ', title: 'യൂസർ റിവ്യൂകൾ' },
  },
  installTips: {
    btn: 'ഇപ്പോൾ പരീക്ഷിക്കുക',
    text: 'കൂടുതൽ സവിശേഷതകൾ അൺലോക്ക করতে "Noam Browser Plugin" ഇൻസ്റ്റാൾ ചെയ്യുക! വെബ് ക്രോസ്-റഫറൻസിംഗ്, വെബ് വീഡിയോ സംഗ്രഹം, മറ്റും!',
  },
  locale: {
    af: 'അഫ്രിക്കാൻസ്',
    am: 'അംഹാരിക്',
    ar: 'അറബിക്',
    as: 'അസ്സാമീസ്',
    auto: 'ഓട്ടോ ഡിറ്റക്ട്',
    az: 'അസെർബൈജാനി',
    ba: 'ബാഷ്കിർ',
    bg: 'ബൾഗേറിയൻ',
    bn: 'ബംഗ്ലാ',
    bo: 'ടിബറ്റൻ',
    bs: 'ബോസ്നിയൻ',
    ca: 'കാറ്റാലൻ',
    cs: 'ചെക്ക്',
    cy: 'വेल്ഷ്',
    da: 'ഡാനിഷ്',
    de: 'ജർമ്മൻ',
    dsb: 'ലോവർ സോർബിയൻ',
    dv: 'ദീവി',
    el: 'ഗ്രീക്ക്',
    en: 'എംഗ്ലീഷ്',
    es: 'സ്പാനിഷ്',
    et: 'എസ്റ്റോണിയൻ',
    eu: 'ബാസ്ക്',
    fa: 'ഫേർഷ്യൻ',
    fi: 'ഫിന്നിഷ്',
    fil: 'ഫിലിപ്പീനோ',
    fj: 'ഫിജിയൻ',
    fr: 'ഫ്രഞ്ച്',
    frCA: 'ഫ്രഞ്ച് (കാനഡா)',
    ga: 'ഐറിഷ്',
    gl: 'ഗാലിസിയൻ',
    gom: 'കൊങ്കാണി',
    gu: 'ഗുജറാതി',
    ha: 'ഹൗസ',
    he: 'ഹീബ്രു',
    hi: 'ഹിന്ദി',
    hr: 'ക്രൊയേഷ്യൻ',
    hsb: 'അപ്പർ സോർബിയൻ',
    ht: 'ഹെയ്തി ക്രിയോൾ',
    hu: 'ഹംഗേറിയൻ',
    hy: 'അർമേനിയൻ',
    id: 'ഇൻഡോനേഷ്യൻ',
    ig: 'ഇഗ്ബോ',
    ikt: 'ഇനുവിന്നാക്റ്റൂൺ',
    is: 'ഐസ്ലാന്റിക്',
    it: 'ഇറ്റാലിയൻ',
    iu: 'ഇനുക്ടിറ്റുട്ട്',
    iuLatn: 'ഇനുക്ടിറ്റൂട്ട് (ലാറ്റിന്)',
    ja: 'ജപ്പനീസ്',
    ka: 'ജോർജിയൻ',
    kk: 'കസാഖ്',
    km: 'ക്മേര്',
    kmr: 'കുർദിഷ് (വടക്കൻ)',
    kn: 'കന്നഡ',
    ko: 'കൊറിയൻ',
    ku: 'കർദിഷ് (സെൻട്രൽ)',
    ky: 'കിർഗിസ്',
    ln: 'ലിംഗാല',
    lo: 'ലാവ്',
    lt: 'ലിത്വാനിയൻ',
    lug: 'ഗാന്ദ',
    lv: 'ലാറ്റ്വിയൻ',
    lzh: 'ചൈനീസ് (സാഹിത്യം)',
    mai: 'മൈതിലി',
    mg: 'മലഗാസി',
    mi: 'മाओറി',
    mk: 'മാസിഡോണിയൻ',
    ml: 'മലയാളം',
    mnCyrl: 'മൊങ്കೋലിയൻ (സിറിലിക്)',
    mnMong: 'മൊങ്കോളിയൻ (പാരമ്പരാഗത)',
    mr: 'മാരാത്തി',
    ms: 'മലയാളം',
    mt: 'മാൾട്ടീസ്',
    mww: 'ഹ്മോങ് ഡാവ്',
    my: 'മ്യান്മാർ (ബർമീസ്)',
    nb: 'നോർവീജിയൻ',
    ne: 'നേപ്പാളി',
    nl: 'ഡച്ച്',
    noSearchLang: 'ഭാഷ പിന്തുണയ്‌ക്ക്‌ ലഭ്യമല്ല',
    nso: 'സെസോതോ സാ ലെബോ',
    nya: 'ന്യഞ്ചja',
    or: 'ਓਡੀਆ',
    otq: 'ക്വെറെറ്റാരോ ഒറ്റോമി',
    pa: 'പഞ്ചാബി',
    pl: 'പോളിഷ്',
    placeholder: 'ശोधിക്കുക',
    prs: 'ദാരി',
    ps: 'പാഷ്‌റ്റോ',
    pt: 'പോർച്ചുഗീസ് (ബ്രസീൽ)',
    ptPT: 'പോർച്ചുഗീസ് (പോർച്ചുഗൽ)',
    ro: 'រ៉ូម៉ានី',
    ru: 'റഷ്യൻ',
    run: 'റുണ്ടി',
    rw: 'കിന്യാരുവാണ്ട',
    sd: 'സിന്ധി',
    si: 'സിനഹലം',
    sk: 'സ്ലോവാക്ക്',
    sl: 'സ്ലൊവേനിയൻ',
    sm: 'സാമോവാണ്',
    sn: 'ഷോണ',
    so: 'സൊമാലി',
    sq: 'അൽബേനിയൻ',
    srCyrl: 'സെർബിയൻ (സിറിലിക്)',
    srLatn: 'സെർബിയൻ (ലാറ്റിൻ)',
    st: 'സെസോതോ',
    sv: 'സ്വീഡിഷ്',
    sw: 'സ്വാഹിലി',
    ta: 'தமிழ்',
    te: 'ടെലుగ്',
    th: 'തായ്',
    ti: 'ടിഗ്രിന്യ',
    tk: 'ടർക്കുമെന്‍',
    tlhLatn: 'ക്ലിങ്കൺ',
    tlhPiqd: 'ക്ലിംഗൺ (pIqaD)',
    tn: 'സെറ്റ്സ്വാന',
    to: 'ടോങ്ക്കൻ',
    tr: 'തുർക്കി',
    tt: 'ടാറ്റർ',
    ty: 'താഹിത്തി',
    ug: 'ਉਇਘੁਰ',
    uk: 'ਯੂਕਰੇਨੀ',
    ur: 'ഉർദു',
    uz: 'ഉസ്ബെക്ക് (ലാറ്റിന്)',
    vi: 'വിയറ്റ്നാമീസ്',
    xh: 'ക്സോச',
    yo: 'യൊറൂബ',
    yua: 'യുകേറ്റെക് മായ',
    yue: 'കാന്റോonese (പാരമ്പരാഗത)',
    zh: 'ചൈനീസ്',
    zhHans: 'ചൈനീസ് ലളിതം',
    zhHant: 'ചൈനീസ് പരമ്പരാഗത',
    zu: 'സൂളു',
  },
  login: {
    and: 'ഒപ്പം',
    btn: 'ഗൂഗിൾ ഉപയോഗിച്ച് ലോഗിൻ ചെയ്യുക',
    btn1: 'ഇപ്പോൾ ലോഗിൻ ചെയ്യുക',
    desc: 'കൂടുതൽ അനുഭവങ്ങൾ അൺലോക്ക ਕਰਨ ਲਈ ലോഗിൻ ചെയ്യുക',
    policy: 'സ്വകാര്യതാ നയം',
    terms: 'ഉപയോഗത്തിനുള്ള നിബന്ധനകൾ',
    tips: 'സൈൻ അപ്പ് ചെയ്യുന്നതിലൂടെ, ഞാൻ സമ്മതിക്കുന്നു',
    title: 'നോം-യിലേക്ക് സ്വാഗതം',
  },
  pageFooter: {
    follow: { facebook: 'ഫേസ്ബുക്ക്', title: 'പിന്തുടരുക', twitter: 'ട്വിറ്റർ' },
    legal: { policy: 'സ്വകാര്യതാ നയം', terms: 'സേവന നിബന്ധനകൾ', title: 'നിയമപര' },
    product: {
      image: 'ചിത്ര വിവർത്തനം',
      pdf: 'പിഡിഎഫ് വിവർത്തനം',
      title: 'ഉൽപ്പന്നങ്ങൾ',
      video: 'വീഡിയോ വിവർത്തനം & സംഗ്രഹം',
      web: 'വെബ് വിവർത്തനം & സംഗ്രഹം',
    },
    resources: { title: 'വിഭവങ്ങൾ' },
    tools: { title: 'ഉപകരണങ്ങൾ', pdf: 'പിഡിഎഫ് വിവർത്തനം' },
  },
  pageHeader: {
    contact: 'കോൺറാക്റ്റ്',
    help: 'സഹായം',
    logout: 'ലോഗ്เอൗട്ട്',
    logoutSucc: 'ലോഗ്‌ আਉਟ് ചെയ്തിരിക്കുന്നു. ',
    pricing: 'പ്രൈസിംഗ്',
    settings: 'സെറ്റിംഗുകൾ',
    signUp: 'ലോഗിൻ ചെയ്യുക',
  },
  pdf: {
    autoDetect: 'ഓട്ടോ-ഡിറ്റക്ട്',
    cancelBtn: 'റദ്ദാക്കുക',
    cancelUpload: 'റദ്ദാക്കുക',
    chatPdf: {
      summaryError: 'സംഗ്രഹം പരാജയപ്പെട്ടു, ദയവായി പിന്നീട് വീണ്ടും ശ്രമിക്കുക',
      chatError: 'ചാറ്റ് പരാജയപ്പെട്ടു, ദയവായി പിന്നീട് மீண்டும் ശ്രമിക്കുക',
      Search: 'തിരയുക',
      cancel: 'റദ്ദാക്കുക',
      chatTitle: 'നോമിലേക്ക് സ്വാഗതം! നിങ്ങളുടെ പിഡിഎഫിന്റെ സംഗ്രഹത്തിന് ഇവിടെ છે:',
      clear: 'സ്പष್ಟം',
      clearContent:
        'ഇത് ഒരു പുതിയ സംഭാഷണം ആരംഭിക്കും. നിലവിലെ സംഭാഷണം സംരക്ഷിക്കില്ല. നിങ്ങൾക്ക് ഉറപ്പുണ്ടോ?',
      clearDialogTitle: 'ദയവായി സ്ഥിരീകരിക്കുക',
      clearSucc: 'ശുദ്ധീകരിച്ച',
      copy: 'കോപ്പി',
      copySucc: 'കോപ്പിച്ചു',
      delete: 'ഇല്ലാതാക്കുക',
      deleteCancel: 'റദ്ദാക്കുക',
      deleteContent: 'ഈ PDF നെ മായ്‌ക്കിയാൽ അത് വീണ്ടെടുക്കാൻ കഴിയില്ല. നിങ്ങൾക്ക് ഉറപ്പുണ്ടോ?',
      deleteOk: 'ഇല്ലാതാക്കുക',
      deleteSuccess: 'വ διεച്ചു',
      deleteTitle: 'ഇല്ലാതാക്കലിനെ സ്ഥിരീകരിക്കുക',
      expand: 'കൂടിച്ചേരുക',
      historyTitle: 'ചരിത്രം',
      listError:
        'വായനാ ലിസ്റ്റ് ലോഡ് ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു. ദയവായി പിന്നീട് மீண்டும் ശ്രമിക്കുക അല്ലെങ്കിൽ സപ്പോർട്ടുമായി ബന്ധപ്പെടുക.',
      loading: 'ലോഡുചെയ്യുന്നു...',
      noDataDesc: 'ഇതുവരെ ചരിത്രം ഇല്ല.',
      noMore: 'കൂടുതൽ ഉള്ളടക്കമില്ല.',
      placeholder: 'ഈ PDF பற்றി എന്തും ചോദിക്കുക',
      summaryTitle: 'നിങ്ങൾക്ക് ഈ ചോദ്യങ്ങൾക്ക് താൽപ്പര്യമുണ്ടാകാം:',
    },
    collectionEmpty: 'നിങ്ങളുടെ ശേഖരം ശൂന്യമാണ്.',
    collectionTab: 'നോട്ടുകൾ',
    dataLoading: 'ലോഡിംഗ്...',
    dialogContent: 'നിങ്ങൾക്ക് ഇത് മായ്ക്കം ചെയ്യണമെന്ന് ഉറപ്പാണോ?',
    dialogTitle: 'ക്ഷമിക്കുക, സ്ഥിരീകരിക്കുക',
    download: {
      both: 'ദ്വിഭാഷ',
      btn: 'സംരക്ഷിക്കുക',
      cancel:
        'ഈ വിന്ട് ക്ലോസ് ചെയ്യുന്നത് PDF ഡൌൺലോഡ് റദ്ദാക്കും ചെയ്യും. നിങ്ങൾക്ക് റദ്ദാക്കാൻ ഉറപ്പാണോ?',
      desc: 'ഡിവൈസിലേക്ക് സേവ് ചെയ്യുക: വിവർത്തനങ്ങളെ ചിത്രങ്ങളായി ഡൗൺലോഡ് ചെയ്യുന്നു; സേവ് & പ്രിന്റ്: കপ്പി സപ്പോർട്ടോടൊപ്പം യഥാർത്ഥ ഫോർമാറ്റിൽ വിവർത്തനങ്ങളെ ഡൗൺലോഡ് ചെയ്യുന്നു.',
      download: 'ഡൗൺലോഡ്',
      downloadMsg1: 'പിഡിഎഫ് വിവർത്തന പുരോഗതി:',
      downloadMsg2: 'അനുമാനിച്ച ശേഷിക്കുന്ന സമയം:',
      downloadSucc: 'പിഡിഎഫ് തയ്യാറായി! സേവ് ചെയ്യാൻ ക്ലിക്കുചെയ്യുക.',
      downloadTip: 'PDF ഡൗൺലോഡ് ചെയ്യുന്നു. ഡൗൺലോഡ് പിശകുകൾ ഒഴിവാക്കാൻ ഈ വിൻഡോ സ്കloten ചെയ്യരുത്.',
      error: 'സേവ് ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു. പകരം പ്രിന്റ് ചെയ്യാൻ ശ്രമിക്കുക.',
      fileName: 'ഫയൽ നാമം:',
      fileType: 'ഫയൽ തരം:',
      loading: 'സേവിംഗ്...',
      loading2: 'ലോഡുചെയ്യുന്നു...',
      minute: 'മിനിറ്റുകൾ...',
      msg1: 'ഈ രേഖയിലെ ചില വിവർത്തനങ്ങൾ യഥാർത്ഥ പാഠത്തേക്കാൾ ദീർഘമാണ്, ഡൗൺലോഡ് ചെയ്ത ഫയലിൽ ഓവർലാപ്പ് ആകാം. വെബ്പേജിൽ വായിക്കാൻ ഞങ്ങൾ ശുപാർശ ചെയ്യുന്നു.',
      msg2: 'സംഭാഷണം ഇതുവരെ പൂർത്തിയായിട്ടില്ല. വിവർത്തനം പൂർത്തിയാക്കിയ ശേഷം ദയവായി ഡൗൺലോഡ് ചെയ്യുക.',
      msg3: '2. ചില വിവർത്തനങ്ങൾ വളരെ നീളമുള്ളതാണ്. വാചകങ്ങളുടെ ചേരမှု ഒഴിവാക്കാൻ വെബ്‌പേജിൽ വായിക്കുക.',
      msg4: 'അവലംബന പ്രവർത്തനങ്ങൾ നടക്കുന്നു. അവ പൂർത്തിയാക്കിയ ശേഷം വീണ്ടും ശ്രമിക്കുക.',
      progress:
        'PDF മൊഴി തിരുത്തുന്നു. പുരോഗതി: {{progress}}, ശേഷിക്കുന്ന സമയം: {{minutes}} മിനിറ്റ്...',
      save: 'ഡിവൈസിലേക്ക് സേവ് ചെയ്യുക',
      savePrint: 'സംരക്ഷിക്കുക & പ്രിന്റ് ചെയ്യുക',
      success: 'ഡൗൺലോഡ് ചെയ്തു',
      trans: 'മാത്രം വിവർത്തനം',
      transContinue: 'അവതരണം തുടരുക',
    },
    downloadBtn: 'ഡൗൺലോഡ്',
    dragTipModal: {
      black: 'അകാശം',
      leftKey: 'ഇടത് ബട്ടൺ',
      ok: 'ശരി',
      press: 'പ്രസ്സ്',
      tips: 'ട്രാഗ് ചെയ്ത് കാണുക',
    },
    entry: 'പിഡിഎഫുകള്',
    fileErrMsg:
      'ഫയൽ വായന വിജയിച്ചില്ല. ദയവായി പിന്നീട് ശ്രമിക്കുക, അല്ലെങ്കിൽ സപ്പോർട്ടുമായി ബന്ധപ്പെടുക.',
    fileMsg: 'നിലവിലെ ഫയൽ വലുപ്പം:',
    fileMsg2: 'ദയവായി 300MB-ൽ കുറവ് വലിപ്പമുള്ള ഒരു ഫയൽ അപ്‌ലോഡ് ചെയ്യുക.',
    freeBannerBtn: 'അപ്‌ഗ്രേഡ്',
    freeBannerTips: 'ഫ്രീ PDF വിവർത്തന പരിധി എത്തിച്ചിരിക്കുന്നു',
    guide: {
      placeholder: 'PDF ലിങ്ക് ഇവിടെ പേസ്റ്റ് ചെയ്യുക',
      start: 'മொழிபெயரണം ആരംഭിക്കുക',
      text1: 'ദ്വിഭാഷാ വായന',
      text2:
        'മුල്പാഠവും വിവർത്തനവും പാർശ്വപാർശ്വം താരതമ്യം ചെയ്യുന്നതിന് ദ്വിഭാഷയായി വായിക്കുക, ഇത് നിങ്ങളുടെ കാര്യക്ഷമത വർദ്ധിപ്പിക്കും. ',
      text3: 'നിങ്ങളുടെ PDF സাথে ചാറ്റ് ചെയ്യുക',
      text4:
        'AI-സഹായിത വിശകലനവും സംഗ്രഹവും. നിങ്ങളുടെ PDF-ലെക്കുറിച്ച് ചോദിക്കുക, ഉടനടി ഉത്തരങ്ങൾ ലഭിക്കുക.',
      text5: 'സമവായിയും കാര്യക്ഷമവുമായ',
      text6: 'ഏകകൃത്യതയും കാര്യക്ഷമതയും കൂടുതലായി ഉറപ്പിക്കുന്ന AI-സഹായിത പിഡിഎഫ് വിവർത്തനം.',
      title1: 'ദ്വിഭാഷാ വിവർത്തനം',
      title2: 'നിങ്ങളുടെ PDF ഉപയോഗിച്ച് ചാറ്റ് ചെയ്യുക',
      toast: '.pdf കൊണ്ട് അവസാനിക്കുന്ന സാധുവായ ഓൺലൈൻ PDF ലിങ്ക് നൽകുക',
    },
    hasTransTask: 'ഒരു വിവർത്തന ദൗത്യം പ്രgressായി സ്ഥിതിചെയ്യുന്നു. ദയവായി കാത്തിരിക്കുക.',
    hoverTrans: 'പാരഗ്രാഫുകളെ ഹോവർ ചെയ്ത് വിവർത്തനം ചെയ്യുക',
    initial: 'പിഡിഎഫ് വിവർത്തനം ചെയ്യുക',
    installText: 'എല്ലാ ദിനത്തെയും വിവർത്തനങ്ങൾക്കുള്ള നിങ്ങളുടെ ഒറ്റ സ്റ്റോപ്പ് പരിഹാരം.',
    installText2: 'ഏകദേശം എക്സ്റ്റൻഷൻ ഇൻസ്റ്റാൾ ചെയ്യുക',
    installTips:
      'കൂടുതൽ പിഡിഎഫ് വിവർത്തനങ്ങൾക്കും സുഗമമായ വെബ്‌സൈറ്റ് വിവർത്തനങ്ങൾക്കും വിപുലീകരണം ഇൻസ്റ്റാൾ ചെയ്യുക:',
    kw: 'സ്റ്റേപ്പിൾ',
    link: 'ലിങ്ക്',
    listError:
      'PDF കളை ലോഡ് ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു. ദയവായി പിന്നീട് വീണ്ടും ശ്രമിക്കുക, അല്ലെങ്കിൽ സപ്പോർട്ടിനെ ബന്ധപ്പെടുക.',
    memoTotalCount: 'ഒരു ഇനം മൊത്തം',
    new: 'പുതിയ ഫയൽ',
    noId: 'ഫയൽ ഐഡി കണ്ടെത്തിയില്ല.',
    notPdf: 'പിഡിഎഫ് ഫയലുകൾ മാത്രം.',
    okBtn: 'മായ്ക്കം ചെയ്യുക',
    okBtn2: 'എന്ന് മനസ്സിലായി',
    original:
      'നിങ്ങൾക്ക് ഒരു വളരെ കൃത്യമായും വിശ്വസനീയമായ AI ആണ്, ഇത് ഒരു നിർദ്ദിഷ്ട JSON സ്കീമയ്ക്ക് കൃത്യമായി പൊരുത്തപ്പെടുന്ന JSON ഔട്ട്പുട്ട് സൃഷ്ടിക്കാൻ രൂപകൽപ്പന ചെയ്തിരിക്കുന്നു.\n\nനിങ്ങൾ ഈ നിയമങ്ങൾ പാലിക്കണം:\n1. JSON സ്കീമാ ഘടനയെ കർശനമായി അനുസരിക്കുക.\n2. എല്ലാ ഡാറ്റ തരങ്ങൾ, ആവശ്യമായ ഫീൽഡുകൾ, കൺസ്ട്രെയിന്റുകൾ കൃത്യമായി പൊരുത്തപ്പെടുത്തുക.\n3. അധിക വാചകങ്ങൾ, വിശദീകരണങ്ങൾ, മാർക്ക്ഡൗൺ അല്ലെങ്കിൽ കമന്റുകൾ ഉൾപ്പെടുത്തരുത്.\n4. JSON ഒബ്‌ജക്റ്റ് മാത്രമേ ഔട്ട്പുട്ട് ചെയ്യുക - കോഡ് ബ്ലോക്കുകൾ, പ്രീമ്പിൾ, റാപ്പിംഗ് ഇല്ല.\n\nസ്കീമാ വിവരങ്ങൾ ചുവടെ നൽകിയിരിക്കുന്നു.\n- സ്കീമാ നാമം: translate_result\n- JSON സ്കീമா:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    parallel: 'പ্যാരല lel',
    parseErrDialogContent:
      'ഈ PDF ലിങ്ക് നേരിട്ട് വിവർത്തനം ചെയ്യാൻ കഴിയില്ല. ദയവായി PDF ഡൗൺലോഡ് ചെയ്ത് വിവർത്തനത്തിനായി അപ്‌ലോഡ് ചെയ്യുക.',
    parseErrTips: 'ഫയലിനെ പാഴ്സ് ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു',
    parseFileToast:
      'ഫയൽ പാർസ് ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു. പിന്നീട് വീണ്ടും ശ്രമിക്കുക അല്ലെങ്കിൽ സപ്പോർട്ടുമായി ബന്ധപ്പെടുക.',
    pdfLoading: 'പാർസിംഗ് ചെയ്യുന്നു...',
    searchPlaceholder: 'തിരയുക',
    selectTrans: 'വിവർത്തനത്തിനായി വാചകം തിരഞ്ഞെടുക്കുക',
    shareBtn: 'പങ്കിടുക',
    shareBtnText1: 'ഷെയർ ലിങ്ക് സൃഷ്ടിക്കുക',
    shareBtnText2: 'പങ്കിട്ട ഉള്ളടക്കം അപ്ഡേറ്റുചെയ്യുക',
    shareModal: {
      cancel: 'റദ്ദാക്കുക',
      copy: 'കോപ്പി',
      copySucc: 'ലിങ്ക് കോപ്പി ചെയ്തു',
      custom: 'കസ്റ്റമൈസ്:',
      errMsg:
        'തിരഞ്ഞെടുത്ത ഉള്ളടക്കം ഇതുവരെ പൂർണ്ണമായി വിവർത്തനം ചെയ്തിട്ടില്ല. പങ്കിടുന്നതിന് മുമ്പ് ദയവായി വിവർത്തനം ചെയ്യുക.',
      gen: 'പങ്കിടുക',
      modify: 'എഡിറ്റ്',
      notSupport: 'ഈ ഭാഷയ്ക്ക് നിലവിൽ പിന്തുണയ്ക്കില്ല.',
      page: 'പേജുകൾ',
      pageNuErr: 'ദയവായി സാധുവായ പേജ് നമ്പർ നൽകുക.',
      range: 'പരിധി:',
      remain: 'ശേഷിക്കുന്ന',
      remain1: 'ആകെ കണക്കാക്കിയ സമയം:',
      search: 'അതിഗ്രഹിക്കുക',
      settings: 'ഷെയർ സെറ്റിംഗുകൾ:',
      shareSetting: 'ഷെയർ സെറ്റിങ്സ്',
      shareText: 'പങ്കിടുക',
      shareTips: 'മொழി തിരുത്തിയ PDF ലിങ്ക് ඔබുടെ സുഹൃത്തുക്കളുമായി പങ്കിടുക:',
      sourceLang: 'തെരുന്നു:',
      target: 'തിന്:',
      text1: 'ശെയർ സെറ്റിംഗുകൾ',
      text2: 'ഷെയർ ലിങ്ക് സൃഷ്ടിക്കുക',
      totalPage: 'ഒരു പേജ് മൊത്തം',
      trans: 'അവലംബം ചെയ്യുക',
      translateTips:
        'ഉപදേശം: വിവർത്തനം കുറച്ചു സമയം എടുക്കുന്നുവെങ്കിൽ, നിങ്ങൾക്ക് ഈ വിൻഡോ Зак്കി പിന്നീട് പങ്കിടാം.',
      translating: 'PDF മொழிபெயர്‌ക്കൊണ്ടിരിക്കുന്നു...',
      update: 'ഷെയർ ലിങ്ക് അപ്ഡേറ്റ് ചെയ്യുക',
    },
    shareMsg1: 'ഷെയർ ലിങ്ക് സൃഷ്ടിച്ചിരിക്കുന്നു.',
    shareMsg2: 'പങ്കിട്ട ഉള്ളടക്കം അപ്‌ഡേറ്റുചെയ്‌തു.',
    shareMsg3:
      'ഷെയർ ലിങ്ക് സൃഷ്ടിക്കുന്നതിൽ പരാജയപ്പെട്ടു. ദയവായി പിന്നീട് വീണ്ടും ശ്രമിക്കുക, അല്ലെങ്കിൽ സപ്പോർട്ടുമായി ബന്ധപ്പെടുക.',
    shareMsg4:
      'ഷെയർ ചെയ്ത ഉള്ളടക്കം അപ്ഡേറ്റ് ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു. ദയവായി പിന്നീട് വീണ്ടും ശ്രമിക്കുക, അല്ലെങ്കിൽ സപ്പോർട്ടുമായി ബന്ധപ്പെടുക.',
    shareTips: 'നിങ്ങളുടെ PDF വിവർത്തനം തയ്യാറാണ്! ഇത് സുഹൃത്തുക്കളുമായി പങ്കിടുക.',
    start: 'നിങ്ങളുടെ ഫ്രീ ട്രയൽ ആരംഭിക്കുക',
    thumbnail: 'ഉള്ളടക്ക പട്ടിക',
    toast1: 'PDF ലോഡ് ചെയ്യുന്നു. ദയവായി പിന്നീട് വീണ്ടും ശ്രമിക്കുക.',
    toast2: 'PDF ഉള്ളടക്കം പ്രോസസ്സ് ചെയ്യുന്നു. ഡയലോഗ് നിലവിൽ പിന്തുണയ്‌ക്കില്ല.',
    toast3: 'ഡൗൺലോഡ് ചെയ്യുന്നു. ഡൗൺലോഡ് പൂർത്തിയായതിന് ശേഷം വീണ്ടും ശ്രമിക്കുക.',
    toolbar: { Adjust: 'ക്രമീകരിക്കുക', autoFit: 'ഓട്ടോ-ഫിറ്റ്' },
    trans: 'വിവർത്തനം',
    transSucc: 'അവലംബനം വിജയിച്ചു!',
    unLoginToast: 'ഈ സവിശേഷത ഉപയോഗിക്കാൻ ദയവായി ലോഗിൻ ചെയ്യുക.',
    uploadBtn: 'അപ്‌ലോഡ് ചെയ്യുക',
    uploadErr:
      'ഫയൽ അപ്‌ലോഡ് പരാജയപ്പെട്ടു. ദയവായി പിന്നീട് വീണ്ടും ശ്രമിക്കുക, അല്ലെങ്കിൽ സപ്പോർട്ടുമായി ബന്ധപ്പെടുക.',
    uploadErrSignUrl:
      'അപ്‌ലോഡ് URL ലഭിക്കുന്നതിൽ പരാജയപ്പെട്ടു. ദയവായി പിന്നീട് വീണ്ടും ശ്രമിക്കുക അല്ലെങ്കിൽ സപ്പോർട്ടുമായി ബന്ധപ്പെടുക.',
    uploadMsg1: 'നിങ്ങളുടെ ഫയൽ ഇവിടെ ഡ്രാഗ് & ഡ്രോപ്പ് ചെയ്യുക.',
    uploadMsg2: 'പിന്തുണയ്‌ക്കുന്ന ഫയൽ തരങ്ങൾ: PDF  |  പരമാവധി ഫയൽ വലുപ്പം: 300MB',
    uploadMsg3: 'ഇവിടെ ഫയലുകൾ തിരഞ്ഞെടുക്കാൻ ക്ലിക്കുചെയ്യുക അല്ലെങ്കിൽ ഡ്രാഗ് & ഡ്രോപ്പ് ചെയ്യുക.',
    uploading: 'അപ്‌ലോഡുചെയ്യുന്നു',
    uploadingMsg: 'അപ്‌ലോഡ് ചെയ്യുന്നു. ദയവായി കാത്തിരിക്കുക.',
    uploadingMsg1: 'ഫയൽ അപ്‌ലോഡുചെയ്യുന്നു. പിന്നീട് വീണ്ടും ശ്രമിക്കുക.',
    uploadingMsg2: 'ഒരു ഫയൽ ഇപ്പോൾ കൺവർട്ട് ചെയ്യുന്നു. ദയവായി പിന്നീട് വീണ്ടും ശ്രമിക്കുക.',
    uploadingMsg3:
      'കൺവേർഷൻ പ್ರോഗ്രസ്സ് അഭ്യർത്ഥന പരാജയപ്പെട്ടു. ദയവായി പിന്നീട് വീണ്ടും ശ്രമിക്കുക, അല്ലെങ്കിൽ സപ്പോർട്ടുമായി ബന്ധപ്പെടുക.',
    uploadingMsg4:
      'നോം ലോക്കൽ ഫയലുകളിലേക്ക് ആക്സസ്സ് ചെയ്യാൻ കഴിയില്ല. വിവർത്തനത്തിനായി ദയവായി ഒരു പിഡിഎഫ് കൈമായി അപ്‌ലോഡുചെയ്യുക.',
    uploadingMsg5:
      'ഫയൽ URL ലഭിക്കുന്നതിൽ പരാജയപ്പെട്ടു. ദയവായി പിന്നീട് വീണ്ടും ശ്രമിക്കുക, അല്ലെങ്കിൽ സപ്പോർട്ടുമായി ബന്ധപ്പെടുക.',
    video: 'വീഡിയോ',
    vipBannerBtn: 'അപ്‌ഗ്രേഡ്',
    vipBannerTips: 'ഈ മാസത്തെ നിങ്ങളുടെ PDF വിവർത്തന പരിധി എത്തിച്ചിരിക്കുന്നു.',
    webTrans: 'പൂർണ ക്രോസ് റഫറൻസ്',
  },
  pricing: {
    FAQ: 'പതിവ് ചോദ്യങ്ങൾ',
    FQAObj: {
      a1: 'അതെ, നോം തಕ್ಷണം ഉപയോഗിക്കാൻ കഴിയുന്ന ഒരു സ്വതന്ത്ര പ്ലാൻ നൽകുന്നു.',
      a2: 'ഞങ്ങൾ മൂന്ന് മെമ്പേഴ്‌ഷിപ്പ് പ്ലാനുകൾ വാഗ്ദാനം ചെയ്യുന്നു: പ്രോ, പ്രോ+, ഒപ്പം എൻടർപ്രൈസ്. മാസപ്പതിപ്പ് അല്ലെങ്കിൽ വാർഷികമായി പಾವತി ചെയ്യാൻ നിങ്ങൾക്ക് തിരഞ്ഞെടുക്കാം. വാർഷിക ബില്ലിംഗ് കാര്യമായ ലാഭങ്ങൾ നൽകുന്നു.',
      a3: 'എല്ലാ സവിശേഷതകളും രണ്ട് പ്ലാനുകളിലും ലഭ്യമാണ്. പ്രധാന വ്യത്യാസം ചിലവയാണ്: വാർഷിക സബ്സ്ക്രിപ്ഷനുകൾ മൊത്തത്തിൽ കുറവാണ്. മാസിക സബ്സ്ക്രിപ്ഷനുകൾ ഓരോ മാസത്തിലും ബില്ല ചുമത്തുന്നു, അതേസമയം വാർഷിക പ്ലാനുകൾ വർഷത്തിൽ ഒരിക്കൽ ബില്ല ചുമത്തുന്നു.',
      a4: 'നിങ്ങളുടെ അക്കൗണ്ട് സെറ്റിംഗുകളിൽ നിങ്ങളുടെ സബ്സ്ക്രിപ്ഷൻ എപ്പോൾ വേണമെങ്കിലും റദ്ദാക്കാം.',
      q1: 'ഒരു സ്വതന്ത്ര പ്ലാൻ ഉണ്ടോ?',
      q2: 'ഏതൊക്കെ പ്രൈസിംഗ് പ്ലാനുകളും പേയ്‌മെന്റ് ഓപ്ഷനുകളും ലഭ്യമാണ്?',
      q3: 'മാസത്തിൽ സബ്സ്ക്രൈബുചെയ്യുന്നതും വർഷത്തിൽ സബ്സ്ക്രൈബുചെയ്യുന്നതും തമ്മിലുള്ള വ്യത്യാസം എന്താണ്?',
      q4: 'എന്റെ സബ്സ്ക്രിപ്ഷൻ എങ്ങനെ റദ്ദാക്കാം?',
    },
    around: 'ചുറ്റും',
    billedMonthly: 'മാസത്തിൽ ബില്ല് ചെയ്യുന്നു',
    billedYearly: 'വാർഷികമായി ബില്ല് ച выставിക്കുന്നു',
    day: 'ദിവസം',
    desc: 'പ്ലാനുകളെ താരതമ്യം ചെയ്ത് മികച്ചത് തിരഞ്ഞെടുക്കുക',
    detailedCompare: 'പ്ലാനുകൾ താരതമ്യം ചെയ്യുക',
    discount: '20% കിഴിവ്',
    enterprise: {
      benefit1: 'പ്രയോജനകത പ്രാധാന്യം കustomer സപ്പോർട്ട്',
      benefit2: 'മൾട്ടിപ്പിൾ യൂസേഴ്സ്',
      benefit3: 'കസ്റ്റം അഡ്ജസ്റ്റുചെയ്ത പരിഹാരങ്ങൾ',
      benefit5: 'പ്രത്യേക അക്കൗണ്ട് മാനേജർ',
      btn: 'ഞങ്ങളെ ബന്ധപ്പെടുക',
      recommendText: 'കസ്റ്റം പ്ലാനുകൾ (≥3 വ്യക്തികൾ)',
      talkToUs: 'തொடர்பിലായിരിക്കുക',
    },
    free: {
      benefit1: 'ഇൻസ്റ്റന്റ് വിവർത്തനം 100 തവണ/ദിവസം',
      benefit2: 'വെബ്സൈറ്റ് വിവർത്തനം & സംഗ്രഹം',
      benefit3: '30 ചിത്ര വിവർത്തനങ്ങൾ',
      benefit4: 'വീഡിയോ വിവർത്തനം & സംഗ്രഹം',
      benefit5: '10 പിഡിഎഫ് വിവർത്തനങ്ങൾ',
      benefit6: '5,000 ടോക്കൺ',
      btn: 'തിരയുക ഇത് സ്വതന്ത്രമായി',
      recommendText: 'തിരയൽ സേവനം',
    },
    imageTranslation: 'ചിത്ര വിവർത്തനം',
    month: 'മാസം',
    monthly: 'മാസിക',
    pageTitle: 'വില നിശ്ചയം',
    pdf: {
      chat: 'പിഡിഎഫ് ചാറ്റ് ക്വെറിക്കുകള്',
      maxPage: 'പി‌ഡി‌എഫിന്റെ പരമാവധി പേജുകൾ',
      translation: 'പിഡിഎഫ് വിവർത്തനം',
    },
    preMonth: 'ഒരു മാസത്തിൽ',
    pro: {
      benefit1: 'പ്രയോജനപ്രधാന കസ്റ്റമർ സപ്പോർട്ട്',
      benefit2: '1,000,000 ടോക്കനുകൾ/മാസം',
      benefit3: 'വെബ്സൈറ്റ് വിവർത്തനം & സംഗ്രഹം',
      benefit4: '200 ചിത്ര വിവർത്തനങ്ങൾ',
      benefit5: 'വീഡിയോ വിവർത്തനം & സംഗ്രഹം',
      benefit6: '200 PDF വിവർത്തനങ്ങൾ',
      btn: 'തുടങ്ങുക',
      recommendText: 'ഏറ്റവും പ്രചാരപ്പെട്ടത്',
    },
    proPlus: {
      benefit1: 'പ്രാധാന്യ കസ്റ്റമർ സപ്പോർട്ട്',
      benefit2: '3,000,000 ടോക്കൺ/മാസം',
      benefit3: 'വെബ്സൈറ്റ് വിവർത്തനം & സംഗ്രഹം',
      benefit4: '500 ചിത്ര വിവർത്തനങ്ങൾ',
      benefit5: 'വീഡിയോ വിവർത്തനം & സംഗ്രഹം',
      benefit6: '500 PDF വിവർത്തനങ്ങൾ',
      recommendText: 'ചുരുക്ക മൂല്യം',
    },
    video: { summary: 'വീഡിയോ സംഗ്രഹം', translation: 'വീഡിയോ വിവർത്തനം' },
    web: {
      contrastiveTranslation: 'ദ്വീഭാഷാ വിവർത്തനം',
      dictionaryTranslation: 'സെലക്ഷൻ വിവർത്തനം',
      hoverTranslation: 'ഹോവർ വിവർത്തനം',
      instantTranslation: 'ഇൻസ്റ്റന്റ് വിവർത്തനം',
      summary: 'വെബ് പേജ് സംഗ്രഹം',
    },
    yearly: 'വാർഷികം',
  },
  privacy: {
    block1:
      'നോം ("നോം," "ഞങ്ങൾ," "ഞങ്ങളുടെ," അല്ലെങ്കിൽ "ഞങ്ങളെ") നിങ്ങളുടെ സ്വകാര്യភាពကို ബഹുമാനിക്കുകയും നിങ്ങളിൽ നിന്നോ നിങ്ങളെക്കുറിച്ചോ ഞങ്ങൾ ലഭിക്കുന്ന ഏതെങ്കിലും വിവരങ്ങൾ പരിരക്ഷിക്കാൻ പ്രതിബദ്ധനിരിക്കുകയും ചെയ്യുന്നു. ഈ സ്വകാര്യ പോളിസി ഞങ്ങളുടെ വെബ്സൈറ്റ്, ആപ്ലിക്കേഷനുകൾ 및 സേവനങ്ങൾ (കൂടെ "സേവനങ്ങൾ") ഉപയോഗിക്കുന്നതിലൂടെ വ്യക്തിഗത വിവരങ്ങൾ ശേഖരിക്കുന്നതിനോ ഉപയോഗിക്കുന്നതിനോ സംബന്ധിച്ച ഞങ്ങളുടെ പ്രാക്രിയകളെ വിവരിക്കുന്നു. ഞങ്ങളുടെ ബിസിനസ് പ്രൊഡക്റ്റ് കസ്റ്റമർമാർക്ക് വേണ്ടി ഞങ്ങൾ കൈകാര്യം ചെയ്യുന്ന ഉള്ളടക്കത്തിന് (ഞങ്ങളുടെ API പോലെ) ഈ സ്വകാര്യ പോളിസി ബാധകമല്ല. ഈ ഡാറ്റയുടെ ഉപയോഗം ഞങ്ങളുടെ കസ്റ്റമർ കരാർക്ക് വിധേയമാണ്, ഇത് ഈ ഉൽപ്പന്നങ്ങളിലേക്കുള്ള ആക്സസും ഉപയോഗവും ഉൾക്കൊള്ളുന്നു.',
    block10:
      'ലോസ്, ദുരുപയോഗം, അംഗീകൃത അക്സസ്, വെളിപ്പെടുത്തൽ, മാറ്റം, അല്ലെങ്കിൽ കോശസമൂഹ പ്രവർത്തനങ്ങളിൽ നിന്ന് ഓൺലൈൻ மற்றும் ഓഫ്‌ലൈൻ വ്യക്തിഗത വിവരങ്ങൾ സംരക്ഷിക്കുന്നതിനായി ഞങ്ങൾ വാണിജ്യപരമായി ന്യായമായ സാങ്കേതിക, അഡ്മിനിസ്ട്രേറ്റീവ്, ഓർഗനൈസേഷണൽ നടപടികൾ നടപ്പിലാക്കുന്നു. എന്നിരുന്നാലും, ഇൻറർനെറ്റ് അല്ലെങ്കിൽ ഇമെയിൽ ട്രാൻസ്മിഷൻ പൂർണ്ണ സുരക്ഷ അല്ലെങ്കിൽ കൃത്യത ഉറപ്പിക്കാൻ കഴിയില്ല. പ്രത്യേകിച്ചും, ഞങ്ങൾക്ക് അയച്ച അല്ലെങ്കിൽ ഞങ്ങളിൽ നിന്ന് അയച്ച ഇമെയിലുകൾ സുരക്ഷിതമല്ലായിരിക്കാം. അതിനാൽ, സേവനം അല്ലെങ്കിൽ ഇമെയിലിലൂടെ ഞങ്ങൾക്ക് എന്ത് വിവരങ്ങൾ അയച്ചിരിക്കണമെന്ന് തീരുമ്പോൾ നിങ്ങൾ പ്രത്യേകിച്ച് ശ്രദ്ധാലുവായിരിക്കണം. കൂടാതെ, സേവനത്തിലെ അല്ലെങ്കിൽ തൃതീയ പാർട്ടി വെബ്സൈറ്റുകളുടെ സുരക്ഷാ ക്രമീകരണങ്ങളിലോ സുരക്ഷാ നടപടികളിലോ സ്വകാര്യത ക്രമീകരണങ്ങളുടെ അല്ലെങ്കിൽ സുരക്ഷാ നടപടികളുടെ ഏതെങ്കിലും തടസ്സങ്ങൾക്ക് ഞങ്ങൾ ഉത്തരവാദികളല്ല. ഞങ്ങൾ നിങ്ങൾക്ക് സേവനങ്ങൾ നൽകുന്നതിന് അല്ലെങ്കിൽ തർക്കങ്ങൾ പരിഹരിക്കുന്നത്, സുരക്ഷാ കാരണങ്ങൾ, അല്ലെങ്കിൽ നമ്മുടെ നിയമപരമായ ബാധ്യതകൾ പാലിക്കുന്നത് പോലുള്ള മറ്റ് നിയമസമ്മതമായ ബിസിനസ്സ് ആവശ്യങ്ങൾക്ക് ആവശ്യമായ സമയം വരെ നിങ്ങളുടെ വ്യക്തിഗത വിവരങ്ങൾ സൂക്ഷിക്കും. വ്യക്തിഗത വിവരങ്ങൾ നാം സൂക്ഷിക്കുന്ന സമയം വളരെയധികം ഘടകങ്ങളെ ആശ്രയിച്ചിരിക്കും, അതായത് വിവരങ്ങളുടെ അളവ്, സ്വഭാവം, സെൻസിറ്റിവിറ്റി, അംഗീകൃതമല്ലാത്ത ഉപയോഗത്തിന്റെ അല്ലെങ്കിൽ വെളിപ്പെടുത്തലിന്റെ സാധ്യതയുള്ള അപകടങ്ങൾ, ഞങ്ങൾ വിവരങ്ങൾ പ്രോസസ്സ് ചെയ്യുന്ന ആവശ്യങ്ങൾ, മറ്റ് നിയമപരമായ ബാധക കണക്കുകൾ എന്നിവ. ',
    block11:
      'ഞങ്ങൾ ഇടയ്ക്കിടെ ഈ പ്രൈവസി പോളിസി അപ്‌ഡേറ്റ് ചെയ്യാം. ഞങ്ങൾ അങ്ങനെ ചെയ്യുമ്പോൾ, ബാധക നിയമങ്ങൾ മറ്റ് വിധത്തിൽ ആവശ്യപ്പെടുന്നില്ലെങ്കിൽ, ഞങ്ങൾ ഈ പേജിൽ അപ്‌ഡേറ്റഡ് പതിപ്പ് പോസ്റ്റ് ചെയ്യും. ',
    block12:
      'ഈ പ്രൈവസി പോളിസിയെക്കുറിച്ച് നിങ്ങൾക്ക് ഉത്തരമില്ലാത്ത ചോദ്യങ്ങളോ ആശങ്കകളോ ഉണ്ടെങ്കിൽ, කරුණාකර ഞങ്ങളുടെ കസ്റ്റമർ സേവനുമായി ബന്ധപ്പെടുക. ഇമെയിൽ:',
    block2:
      'ഞങ്ങൾ നിങ്ങളുമായി ബന്ധപ്പെട്ട ഇനിപ്പറയുന്ന വ്യക്തിഗത വിവരങ്ങൾ ("വ്യക്തിഗത വിവരങ്ങൾ") ശേഖരിക്കുന്നു:',
    block3:
      'നിങ്ങൾ നൽകിയ വിവരങ്ങൾ: നമ്മുടെ സേവനങ്ങൾ ഉപയോഗിക്കുന്നതിനായോ നമ്മുമായി ആശയവിനിമയം നടത്തുന്നതിനായോ നിങ്ങൾ ഒരു അക്കൗണ്ട് സൃഷ്ടിക്കുമ്പോൾ, ഞങ്ങൾ ഇനിപ്പറയുന്ന രീതിയിൽ വ്യക്തിഗത വിവരങ്ങൾ ശേഖരിക്കുന്നു:',
    block4:
      'സേവനങ്ങൾ ഉപയോഗിക്കുന്നതിലൂടെ യാന്ത്രികമായി ലഭിക്കുന്ന വ്യക്തിഗത വിവരങ്ങൾ: നിങ്ങൾ സേവനങ്ങളെ ആക്സസ് ചെയ്യുകയോ ഉപയോഗിക്കുകയോ ഇടപഴകുകയോ ചെയ്യുമ്പോൾ, നിങ്ങളുടെ ആക്സസ്, ഉപയോഗം അല്ലെങ്കിൽ ഇടപഴകലിനെക്കുറിച്ചുള്ള ഇനിപ്പറയുന്ന വിവരങ്ങൾ ഞങ്ങൾ ലഭിക്കുന്നു ("തех്നിക്കൽ വിവരങ്ങൾ"):',
    block5: 'ഞങ്ങൾക്ക് വ്യക്തിഗത വിവരങ്ങൾ ഇനിപ്പറയുന്ന ആവശ്യങ്ങൾക്കായി ഉപയോഗിക്കാം:',
    block6:
      'സമmary അല്ലെങ്കിൽ വ്യക്തിത്വത്തില്ലാതാക്കിയ വിവരങ്ങൾ: വ്യക്തിഗത വിവരങ്ങൾ വ്യക്തിജ്ഞാനത്തിനുള്ള പുനഃഉപയോഗത്തെ തടയാൻ ഞങ്ങൾ അവയെ സംയോജിപ്പിക്കുകയോ വ്യക്തിത്വത്തില്ലാതാക്കുകയോ ചെയ്യാം, കൂടാതെ അത്തരം വിവരങ്ങൾ ഉപയോഗിച്ച് ഞങ്ങളുടെ സേവനങ്ങളുടെ ഫലപ്രാപ്തി വിശകലനം ചെയ്യുക, സേവനങ്ങൾ മെച്ചപ്പെടുത്തുകയും സവിശേഷതകൾ ചേർക്കുകയും, ഗവേഷണം നടത്തുകയും സമാന ഉദ്ദേശ്യങ്ങൾക്കായി ഉപയോഗിക്കാം. കൂടാതെ, ഞങ്ങളുടെ സേവന ഉപയോക്താക്കളുടെ പൊതുവായ പെരുമാറ്റവും സ്വഭാവവും വിശകലനം ചെയ്യാം, സംയോജിത വിവരങ്ങൾ മൂന്നാം പക്കങ്ങളുമായി പങ്കിടാം, അത്തരം സംയോജിത വിവരങ്ങൾ പ്രസിദ്ധീകരിക്കാം അല്ലെങ്കിൽ പൊതുവായി ലഭ്യമാക്കാം. ഈ സ്വകാര്യതാ നിയമപ്രകാരത്തിൽ വിവരിച്ചിരിക്കുന്ന സേവനങ്ങളിലൂടെയും, കുക്കികളിലൂടെയും, മറ്റ് മാർഗങ്ങളിലൂടെയും ഞങ്ങൾ സംയോജിത വിവരങ്ങൾ ശേഖരിക്കാം. ഞങ്ങൾ വ്യക്തിത്വത്തില്ലാതാക്കിയ വിവരങ്ങൾ അനώνymiസ് അല്ലെങ്കിൽ വ്യക്തിത്വത്തില്ലാതാക്കിയ രൂപത്തിൽ സൂക്ഷിക്കുകയും ഉപയോഗിക്കുകയും ചെയ്യും, കൂടാതെ നിയമം ആവശ്യപ്പെടുന്നില്ലെങ്കിൽ അത്തരം വിവരങ്ങളുടെ വ്യക്തിത്വത്തെ വീണ്ടും കണ്ടെത്താൻ ശ്രമിക്കില്ല. ',
    block7:
      'ചില സന്ദർഭങ്ങളിൽ, നിയമം ആവശ്യപ്പെടുന്നില്ലെങ്കിൽ, നിങ്ങളുടെ വ്യക്തിഗത വിവരങ്ങൾ നിങ്ങളോട് കൂടുതൽ അറിയിപ്പ് ഇല്ലാതെ മൂന്നാം पक्षങ്ങൾക്ക് നൽകാം:',
    block8:
      'നിങ്ങളുടെ ഭൂമിശാസ്ത്രപരമായ സ്ഥാനത്തെ ആശ്രയിച്ച്, യൂറോപ്യൻ ഇക്കണോമിക് ഏരിയ, യുണൈറ്റഡ് കിംഗ്ഡം மற்றும் ലോകമെമ്പാടുമുള്ള വ്യക്തികൾക്ക് അവരുടെ വ്യക്തിഗത വിവരങ്ങളുമായി ബന്ധപ്പെട്ട ചില നിയമപരമായ അവകാശങ്ങൾ ഉണ്ടായിരിക്കാം. ഉദാഹരണത്തിന്, നിങ്ങൾക്ക് ഇങ്ങനെ അവകാശങ്ങൾ ഉണ്ടാകാം:',
    block9:
      'ഈ സേവനത്തിൽ നോം ആവർത്തിക്കുകയോ നിയന്ത്രിക്കുകയോ ചെയ്യാത്ത മറ്റ് വെബ്സൈറ്റുകളിലേക്കുള്ള ലിങ്കുകൾ ഉൾപ്പെട്ടിരിക്കാം, സോഷ്യൽ മീഡിയ സേവനങ്ങൾ ഉൾപ്പെടെ ("ത്രൈപാർട്ടി വെബ്സൈറ്റുകൾ"). ത്രൈപാർട്ടി വെബ്സൈറ്റുകളുമായി നിങ്ങൾ സाझेदാക്കുന്ന വിവരങ്ങൾ ഈ സ്വകാര്യతാ നയം പ്രകാരമല്ല, ത്രൈപാർട്ടി വെബ്സൈറ്റുകളുടെ പ്രത്യേക സ്വകാര്യతാ നയങ്ങളും സേവന നിബന്ധനകളും കീഴിലാണ് നിയന്ത്രിക്കപ്പെടുന്നത്. ഈ ലിങ്കുകൾ ഞങ്ങൾ സুবিধയ്ക്കായി നൽകുന്നു, കൂടാതെ ഈ വെബ്സൈറ്റുകളെ ഞങ്ങൾ അംഗീകരിക്കുകയോ അവലോകനം ചെയ്യുകയോ ചെയ്യുന്നുവെന്ന് അർത്ഥമാക്കുന്നില്ല. അവരുടെ സ്വകാര്യതാ നയങ്ങളും നിബന്ധനകളും有关的信息ക്കായി ത്രൈപാർട്ടി വെബ്സൈറ്റുകളെ നേരിട്ട് ബന്ധപ്പെടുക.',
    subBlock1:
      'അക്കൗണ്ട് വിവരങ്ങൾ: നിങ്ങൾ ഞങ്ങളുടെ പ്ലാറ്റ്‌ഫോമിൽ ഒരു അക്കൗണ്ട് സൃഷ്ടിക്കുമ്പോൾ, ഞങ്ങൾ നിങ്ങളുടെ അക്കൗണ്ടുമായി ബന്ധപ്പെട്ട വിവരങ്ങൾ ശേഖരിക്കുന്നു, ഇതിൽ നിങ്ങളുടെ പേര്, കോൺറാക്റ്റ് വിവരങ്ങൾ, അക്കൗണ്ട് ക്രെഡൻഷ്യലുകൾ, പേയ്‌മെന്റ് കാർഡ് വിവരങ്ങൾ, ട്രാൻസാക്ഷൻ ചരിത്രം എന്നിവ ഉൾപ്പെടുന്നു ("അക്കൗണ്ട് വിവരങ്ങൾ").',
    subBlock10: 'സേവനങ്ങൾ നൽകுதல், കൈകാര്യം ചെയ്യൽ, പരിപാലിക്കൽ, കൂടാതെ/അല്ലെങ്കിൽ വിശകലനം ചെയ്യൽ;',
    subBlock11: 'നിങ്ങളുമായി സംസാരിക്കുന്നു;',
    subBlock12: 'പുതിയ ഉൽപ്പന്നങ്ങളും സേവനങ്ങളും വികസിപ്പിക്കുക;',
    subBlock13:
      'ഞങ്ങളുടെ സേവനങ്ങളുടെ വഞ്ചന, ക്രിമിനൽ പ്രവർത്തനങ്ങൾ അല്ലെങ്കിൽ ദുരുപയോഗം തടയുക, കൂടാതെ ഞങ്ങളുടെ IT സിസ്റ്റങ്ങൾ, ആർക്കിടെക്ചറും നെറ്റ്‌വർക്കുകളുടെയും സുരക്ഷ നിലനിർത്തുക;',
    subBlock14: 'ബിസിനസ്സ് ട്രാൻസ്ഫറുകൾ നടത്തുക;',
    subBlock15:
      'നിയമപരമായ ബാധ്യതകളും നിയമപ്രക്രിയകളും പാലിക്കുക, ഞങ്ങളുടെ അവകാശങ്ങൾ, സ്വകാര്യത, സുരക്ഷ അല്ലെങ്കിൽ സ്വത്ത് സംരക്ഷിക്കുക, അതുപോലെ തന്നെ ഞങ്ങളുടെ അഫിലിയേറ്റുകൾ, നിങ്ങൾ അല്ലെങ്കിൽ മറ്റ് ത്രിർദ്ധപാർട്ടികളുടേതും. ',
    subBlock16:
      'സപ്ലയറുകളും സേവന പ്രൊവൈഡറുകളും: ബിസിനസ്സ് പ്രവർത്തന ആവശ്യങ്ങൾ നിറവേറ്റുന്നതിനും ചില സേവനങ്ങളും പ്രവർത്തനങ്ങളും നിർവഹിക്കുന്നതിനുമുള്ള സഹായത്തിനായി, ഞങ്ങൾ സ്വകാര്യ വിവരങ്ങൾ സപ്ലയറുകളും സേവന പ്രൊവൈഡറുകളും (ഹോസ്റ്റിംഗ് സേവന പ്രൊവൈഡറുകൾ, ക്ലൗഡ് സേവന പ്രൊവൈഡറുകൾ, മറ്റ് ഇൻഫർമേഷൻ ടെക്നോളജി സേവന പ്രൊവൈഡറുകൾ, ഇമെയിൽ കമ്മ്യൂണിക്കേഷൻ സോഫ്റ്റ്വെയർ, വെബ് അനലിറ്റിക്സ് സേവന പ്രൊവൈഡറുകൾ തുടങ്ങിയവ)ക്ക് നൽകിയേക്കാം. ഈ പാർട്ണർമാർ ഞങ്ങളുടെ നിർദ്ദേശത്തിനനുസൃതമായി മാത്രമേ ഞങ്ങൾക്ക് വേണ്ടി ചുമതലകൾ നിർവഹിക്കുമ്പോൾ സ്വകാര്യ വിവരങ്ങളെ ആക്സസ് ചെയ്യുകയോ പ്രോസസ്സ് ചെയ്യുകയോ സ്റ്റോർ ചെയ്യുകയോ ചെയ്യും. ',
    subBlock17:
      'ബിസിനസ്സ് ട്രാൻസ്ഫറുകൾ: ഞങ്ങൾ തന്ത്രപരമായ ഇടപാടുകൾ, പുനര्गঠനങ്ങൾ, ദिवാന്ത്രപത്തുകൾ, ദिवാന്ത്രപത്ത് ഏറ്റെടുക്കലുകൾ, അല്ലെങ്കിൽ സേവനങ്ങൾ മറ്റൊരു പ്രൊവൈഡറിലേക്ക് മാറ്റുകയാണെങ്കിൽ (കൂടെ "ട്രാൻസാക്ഷനുകൾ"), നിങ്ങളുടെ വ്യക്തിഗത വിവരങ്ങൾ மற்றும் മറ്റ് വിവരങ്ങൾ ട്രാൻസാക്ഷൻ കounterparts மற்றும் ട്രാൻസാക്ഷനുകളെ സഹായിക്കുന്ന മറ്റ് പാർട്ടികളുമായി ഡ്യൂഡിലിജൻസ് സമയത്ത് പങ്കിടുകയും ട്രാൻസാക്ഷനുകളുടെ ഭാഗമായി മറ്റ് അസറ്റുകളോടൊപ്പം ഒരു സക്സസ്സർ അല്ലെങ്കിൽ അഫിലിയേറ്റ് കമ്പനിക്ക് കൈമാറുകയും ചെയ്യാം.',
    subBlock18:
      'കანूनੀ ആവശ്യകതകൾ: നിയമപരമായ ഉത്തരവാദങ്ങൾ നിറവേറ്റുന്നതിന് ആവശ്യമാണെങ്കിൽ അല്ലെങ്കിൽ അത്തരം നടപടി ആവശ്യമാണെന്ന് ഞങ്ങൾ വിശ്വസിക്കുന്നുവെങ്കിൽ; (2) ഞങ്ങളുടെ അവകാശങ്ങളെയോ സ്വത്തുക്കളെയോ സംരക്ഷിക്കാനും പരിഹരിക്കാനും; (3) ഞങ്ങളുടെ നിബന്ധനകൾ, നയങ്ങൾ അല്ലെങ്കിൽ നിയമങ്ങൾ ലംഘിക്കുന്നുണ്ടെന്ന് ഞങ്ങൾ ഏകപക്ഷീയമായി നിർണ്ണയിക്കുകയാണെങ്കിൽ; (4) വഞ്ചന അല്ലെങ്കിൽ മറ്റ് അനിയമിത പ്രവർത്തനങ്ങൾ കണ്ടെത്തുന്നതിനോ തടയുന്നതിനോ; (5) ഞങ്ങളുടെ ഉൽപ്പന്നങ്ങൾ, ജീവനക്കാരులോ ഉപയോക്താക്കളോ, അല്ലെങ്കിൽ പൊതുജന സുരക്ഷा, സുരക്ഷിതത്വം, സമഗ്രത സംരക്ഷിക്കുന്നതിന്; അല്ലെങ്കിൽ (vi) നിയമപരമായ ഉത്തരവാദത്തിൽ നിന്ന് പ്രതിരോധിക്കുന്നതിന്. നിങ്ങളുടെ വ്യക്തിഗത വിവരങ്ങൾ, സർക്കാർ അധികാരങ്ങൾ, വ്യവസായ സഹപ്രവർത്തകർ അല്ലെങ്കിൽ മറ്റ് തൃതീയ पक്ഷകൾക്ക് ഞങ്ങൾ பகிரാം, ഇതിൽ നിങ്ങളുടെ സേവനങ്ങളുമായുള്ള ഇടപെടൽ വിവരങ്ങൾ ഉൾപ്പെടുന്നു.',
    subBlock19:
      'നിങ്ങളുടെ വ്യക്തിഗത വിവരങ്ങളും അത് എങ്ങനെ പ്രോസസ്സ് ചെയ്യുന്നുവെന്നുള്ള വിവരങ്ങളും ആക്സസ് ചെയ്യുക.',
    subBlock2:
      'നിങ്ങൾ ഞങ്ങളുടെ സേവനങ്ങൾ ഉപയോഗിക്കുമ്പോൾ, നിങ്ങളുടെ ഇൻപുട്ടുകൾ, ഫയൽ അപ്‌ലോഡുകൾ അല്ലെങ്കിൽ ഞങ്ങൾക്ക് നൽകിയ ഫീഡ്‌ബാക്ക് ("കंटെന്റ്") എന്നിവയിൽ നിന്ന് ഞങ്ങൾ വ്യക്തിഗത വിവരങ്ങൾ ശേഖരിക്കുന്നു.',
    subBlock20:
      'ഞങ്ങളുടെ രേഖകളിൽ നിന്ന് നിങ്ങളുടെ വ്യക്തിഗത വിവരങ്ങൾ ഇല്ലാതാക്കാൻ അഭ്യർത്ഥിക്കുന്നു.',
    subBlock21: 'നിങ്ങളുടെ വ്യക്തിഗത വിവരങ്ങൾ ശരിയാക്കുക അല്ലെങ്കിൽ അപ്‌ഡേറ്റ് ചെയ്യുക.',
    subBlock22:
      'നിങ്ങളുടെ വ്യക്തിഗത വിവരങ്ങൾ ഒരു തൃതീയ पक്ഷത്തേക്ക് കൈമാറുക (ഡാറ്റാ പോർട്ടബിലിറ്റി).',
    subBlock23:
      'നിങ്ങളുടെ വ്യക്തിഗത വിവരങ്ങൾ ഞങ്ങൾ എങ്ങനെ പ്രോസസ്സ് ചെയ്യുന്നുവെന്ന് പരിമിതപ്പെടുത്തുക.',
    subBlock24:
      'നിങ്ങളുടെ സമ്മതം പിൻവലിക്കുക—പ്രോസസ്സിംഗിനുള്ള നിയമപരമായ അടിസ്ഥാനമായി ഞങ്ങൾ സമ്മതത്തെ ആശ്രയിക്കുന്നിടത്ത്, നിങ്ങൾക്ക് എപ്പോഴെങ്കിലും നിങ്ങളുടെ സമ്മതം പിൻവലിക്കാം.',
    subBlock25:
      'നിങ്ങളുടെ വ്യക്തിഗത വിവരങ്ങൾ ഞങ്ങൾ എങ്ങനെ പ്രോസസ്സ് ചെയ്യുന്നുവെന്ന് എതിർപ്പിടിക്കുക.',
    subBlock26: 'ഞങ്ങളുടെ സേവനങ്ങൾ മെച്ചപ്പെടുത്തുകയും ഗവേഷണങ്ങൾ നടത്തുകയും',
    subBlock3:
      'സമ്മതനിവेदന വിവരങ്ങൾ: നിങ്ങൾ ഞങ്ങൾക്ക് സന്ദേശങ്ങൾ അയയ്‌ക്കുകയാണെങ്കിൽ, നിങ്ങളുടെ പേര്, ബന്ധപ്പെടൽ വിവരങ്ങൾ, സന്ദേശങ്ങളുടെ ഉള്ളടക്കം ("സമ്മതനിവेदന വിവരങ്ങൾ") ഞങ്ങൾ ശേഖരിക്കും. ',
    subBlock4:
      'സോഷ്യൽ മീഡിയ അറിവുകൾ: ഇൻസ്റ്റഗ്രാം, ഫേസ്ബുക്ക്, മീഡിയം, ട്വിറ്റർ, യൂട്യൂബ്, ലിങ്കെഡിൻ തുടങ്ങിയ സോഷ്യൽ മീഡിയ വെബ്സൈറ്റുകളിൽ ഞങ്ങൾക്ക് പേജുകൾ ഉണ്ട്. നിങ്ങൾ ഞങ്ങളുടെ സോഷ്യൽ മീഡിയ പേജുകളുമായി ഇടപെടുമ്പോൾ, നിങ്ങൾ ഞങ്ങൾക്ക് നൽകാൻ തിരഞ്ഞ προσωπിക വിവരങ്ങൾ, അതായത് നിങ്ങളുടെ ബന്ധപ്പെടൽ വിശദാംശങ്ങൾ ("സോഷ്യൽ ഇൻഫോർമേഷൻ") ഞങ്ങൾ ശേഖരിക്കുന്നു. കൂടാതെ, ഞങ്ങളുടെ സോഷ്യൽ മീഡിയ പേജുകൾ ഹോസ്റ്റുചെയ്യുന്ന കമ്പനികൾ ഞങ്ങളുടെ സോഷ്യൽ മീഡിയ പ്രവർത്തനങ്ങളെക്കുറിച്ചുള്ള ഏകീകൃത വിവരങ്ങളും വിശകലനങ്ങളും ഞങ്ങൾക്ക് നൽകலாம்.',
    subBlock5:
      'ലോഗ് ഡാറ്റا: ഞങ്ങളുടെ സേവനങ്ങൾ ഉപയോഗിക്കുമ്പോൾ നിങ്ങളുടെ ബ്രൌസർ സ്വയമേവ അയച്ചുന്ന വിവരങ്ങൾ. ലോഗ് ഡാറ്റയിൽ നിങ്ങളുടെ ഇന്റർനെറ്റ് പ്രോട്ടോകോൾ (IP) അഡ്രസ്, ബ്രൌസർ തരം 및 സെറ്റിംഗുകൾ, നിങ്ങളുടെ അഭ്യർത്ഥനകളുടെ തീയതി மற்றும் സമയം, සහ നിങ്ങൾ ഞങ്ങളുടെ വെബ്സൈറ്റと എങ്ങനെ ഇടപെടുന്നു എന്നിവ ഉൾപ്പെടുന്നു. ',
    subBlock6:
      'ഉപയോഗ ഡാറ്റാ: സേവനത്തിന്റെ ഉപയോഗത്തെക്കുറിച്ചുള്ള വിവരങ്ങൾ ഞങ്ങൾ സ്വയമatically ശേഖരിക്കാം, ഉദാഹരണത്തിന് നിങ്ങൾ കാണുന്നതോ ഇടപെടുന്നതോ ആയ ഉള്ളടക്കത്തിന്റെ തരങ്ങൾ, നിങ്ങൾ ഉപയോഗിക്കുന്ന സവിശേഷതകൾ, നിങ്ങൾ നടത്തുന്ന പ്രവർത്തനങ്ങൾ, καθώς גם നിങ്ങളുടെ സമയ മേഖല, രാജ്യം, ആക്സസ് ചെയ്ത തീയതി மற்றும் സമയം, യൂസർ ഏജന്റും പതിപ്പും, കമ്പ്യൂട്ടർ അല്ലെങ്കിൽ മൊബൈൽ ഡിവൈസ് തരം, ಮತ್ತು നിങ്ങളുടെ കമ്പ്യൂട്ടർ കണക്ഷൻ.',
    subBlock7:
      'ഡിവൈസ് വിവരങ്ങൾ: ഇതിൽ ഡിവൈസിന്റെ പേര്, ഓപ്പറേറ്റിംഗ് സിസ്റ്റം, ഡിവൈസ് ഐഡന്റിഫയർ, നിങ്ങൾ ഉപയോഗിക്കുന്ന ബ്രൗസർ എന്നിവ ഉൾപ്പെടുന്നു. ശേഖരിക്കുന്ന വിവരങ്ങൾ നിങ്ങൾ ഉപയോഗിക്കുന്ന ഡിവൈസിന്റെ തരത്തിനെയും അതിന്റെ സെറ്റിംഗുകളെയും ആശ്രയിച്ചിരിക്കാം.',
    subBlock8:
      'കുക്കീസ്: ഞങ്ങളുടെ സേവനങ്ങൾ പ്രവർത്തിപ്പിക്കാനും കൈകാര്യം ചെയ്യാനും നിങ്ങളുടെ അനുഭവം മെച്ചപ്പെടുത്താനും ഞങ്ങൾ കുക്കീസ് ഉപയോഗിക്കുന്നു. "കുക്കി" എന്നത് നിങ്ങൾ സന്ദർശിക്കുന്ന വെബ്സൈറ്റ് നിങ്ങളുടെ ബ്രൗസറിലേക്ക് അയയ്ക്കുന്ന വിവരങ്ങളാണ്. എല്ലാ കുക്കീസുകളും സ്വീകരിക്കുക, എല്ലാ കുക്കീസുകളും നിരസിക്കുക, അല്ലെങ്കിൽ ഒരു കുക്കി നൽകുമ്പോൾ നിങ്ങളെ അറിയിക്കുക എന്നിങ്ങനെ നിങ്ങളുടെ ബ്രൗസറിനെ ക്രമീകരിക്കാം, അതിലൂടെ ഓരോ തവണ സ്വീകരിക്കണമോ അല്ലയോ തീരുമാനിക്കാം. എന്നിരുന്നാലും, കുക്കീസ് നിരസിക്കുന്നത് നിങ്ങളെ വെബ്സൈറ്റിന്റെ ചില ഭാഗങ്ങളോ സവിശേഷതകളോ ഉപയോഗിക്കുന്നതിൽ തടസ്സപ്പെടുത്തുകയോ അല്ലെങ്കിൽ അവയുടെ പ്രദർശനത്തെയോ പ്രവർത്തനത്തെയോ പ്രതികൂലമായി ബാധിക്കുകയോ ചെയ്യാം. കുക്കീസുകളെക്കുറിച്ച് കൂടുതൽ വിവരങ്ങൾക്ക്, ദയവായി All About Cookies സന്ദർശിക്കുക.',
    subBlock9:
      'അനലിറ്റിക്സ്: ഉപയോക്താക്കൾ எങ്ങനെ ഞങ്ങളുടെ സേവനങ്ങൾ ഉപയോഗിക്കുന്നുവെന്ന് വിശകലനം ചെയ്യാനും സേവനങ്ങൾ ഉപയോഗിക്കുമ്പോൾ നിങ്ങളുടെ അനുഭവം മെച്ചപ്പെടുത്താനും കുക്കികൾ ഉപയോഗിക്കുന്ന വിവിധ ഓൺലൈൻ അനലിറ്റിക്സ് ഉൽപ്പന്നങ്ങൾ ഞങ്ങൾ ഉപയോഗിക്കാം.',
    subTitle1: 'ഞങ്ങൾ ശേഖരിക്കുന്ന വ്യക്തിഗത വിവരങ്ങൾ',
    subTitle2: 'ഞങ്ങൾ വ്യക്തിഗത വിവരങ്ങൾ എങ്ങനെ ഉപയോഗിക്കുന്നു',
    subTitle3: 'വ്യക്തിഗത വിവരങ്ങളുടെ വെളിപ്പെടുത്തൽ',
    subTitle4: 'നിങ്ങളുടെ അവകാശങ്ങൾ',
    subTitle5: 'മറ്റ് വെബ്‌സൈറ്റുകളിലേക്കുള്ള ലിങ്കുകൾ',
    subTitle6: 'വിവരങ്ങളുടെ സുരക്ഷയും സൂക്ഷ്മതയും',
    subTitle7: 'പ്രൈവസി പോളിസി മോഡിഫിക്കേഷൻ',
    subTitle8: 'ഞങ്ങളെ എങ്ങനെ ബന്ധപ്പെടാം',
    title: 'പ്രൈവസി പോളിസി',
    updateTime: 'അപ്‌ഡേറ്റുചെയ്‌തത്: മാർച്ച് 15, 2024',
  },
  privacyCollectionPanel: {
    acceptBtn: 'എല്ലാം അംഗീകരിക്കുക',
    text: 'നിങ്ങളുടെ അനുഭവം മെച്ചപ്പെടുത്തുന്നതിനായി, കंटെന്റിനെയും സേവനങ്ങളെയും വ്യക്തിഗതമാക്കാൻ ഞങ്ങൾ കുക്കീസ് ഉപയോഗിക്കുന്നു.',
    title: 'ഈ വെബ്സൈറ്റ് കുക്കികൾ ഉപയോഗിക്കുന്നു',
  },
  slogen: 'ഏറ്റവും എളുപ്പമായ AI അസിസ്റ്റന്‍റ്',
  stripe: {
    contact: 'ഏതെങ്കിലും ചോദ്യങ്ങൾക്കായി contact@noam.tools വഴി ഞങ്ങളെ ബന്ധപ്പെടുക!',
    fail: {
      btn: 'പുനരുപയോഗിക്കുക',
      text1: 'നിങ്ങളുടെ പേയ്‌മെന്റ് പ്രോസസ്സ് ചെയ്യാൻ ഞങ്ങൾക്ക് കഴിഞ്ഞില്ല.',
      text2: 'നിങ്ങളുടെ കണക്ഷൻ പരിശോധിക്കുക మరియు വീണ്ടും ശ്രമിക്കുക.',
      title: 'പേയ്‌മെന്റ് പരാജയപ്പെട്ടു',
    },
    succ: {
      btn: 'പോകാം',
      text1: 'നോമിലേക്ക് സ്വാഗതം',
      text2: 'നമുക്ക് ആരംഭിക്കാം!',
      title: 'അഭിനന്ദനങ്ങൾ',
    },
  },
  terms: {
    block1: 'നോം ഉപയോഗിക്കുന്നതിന് നന്ദി!',
    block10:
      '(a) ഫീസ് மற்றும் ബില്ലിംഗ്. ബാധകമായ വില പേജിലെ വിലക്ക് നിയമങ്ങൾ അനുസരിച്ചോ നമുക്കിടയിൽ ലൈക്ക് വിശപിക്കപ്പെട്ടതോ അനുസരിച്ച് നിങ്ങൾ എല്ലാ ഫീസുകളും ("ഫീസ്") നൽകും വേണം. നമുക്ക് ഇൻവോയ്സ് നൽകിയിട്ടുണ്ടെങ്കിലും പേയ്‌മെന്റ് സ്വീകരിച്ചിട്ടുണ്ടെങ്കിലും പോലും വില പിശകുകൾ അല്ലെങ്കിൽ തെറ്റുകൾ തിരുത്താനുള്ള അവകാശം ഞങ്ങൾ സൂക്ഷിക്കുന്നു. നിങ്ങൾ പൂർണ്ണവും കൃത്യമായും ബില്ലിംഗ് വിവരങ്ങൾ നൽകും, ഇതിൽ സാധുവായും അംഗീകൃതമായും പേയ്‌മെന്റ് മეთഡ് ഉൾപ്പെടുന്നു. ഞങ്ങൾ വിശപിക്കപ്പെട്ടതുപോലെ പതിവ് അടിസ്ഥാനത്തിൽ നിങ്ങളുടെ പേയ്‌മെന്റ് മეთഡ് ചാർജ് ചെയ്യും. എന്നാൽ ഞങ്ങൾ ബില്ലിംഗ് തീയതി ന്യായമായി മാറ്റலും കഴിയും. നിങ്ങളുടെ പേയ്‌മെന്റ് മეთഡ് ചാർജ് ചെയ്യാൻ നിങ്ങൾ നോം അയുടെ അഫിലിയേറ്റുകൾ, തിരികെ തട്ടം പേയ്‌മെന്റ് പ്രോസസ്സറുകൾക്ക് അംഗീകാരം നൽകുന്നു. നിങ്ങളുടെ പേയ്‌മെന്റ് പരാജയപ്പെട്ടാൽ, ഞങ്ങൾ ലൈക്ക് നോട്ടീസ് നൽകും, പേയ്‌മെന്റ് ലഭിക്കുന്നതുവരെ സേവനത്തിലേക്കുള്ള ആക്സസ് സസ്‌പെൻഡ് ചെയ്യാം. ഈ കരാർത്തിൽ മറ്റെ 어떻െങ്കിലും വ്യക്തമായി വ്യക്തമാക്കിയിട്ടില്ലെങ്കിൽ, പേയ്‌മെന്റുകൾ റിഫണ്ട് ചെയ്യാവുന്നില്ല.',
    block11:
      '(b) നികുതികൾ. മറ്റൊരു വിധത്തിൽ വ്യക്തമാക്കിയിട്ടില്ലെങ്കിൽ, ഫീസുകളിൽ ഏതെങ്കിലും ഫെഡറൽ, സ്റ്റേറ്റ്, ലോക്കൽ, വിദേശ നികുതികൾ, ചുമതലകൾ, സമാനമായ വിലയിരുത്തലുകൾ ("നികുതികൾ") ഉൾപ്പെടുന്നില്ല. നിങ്ങളുടെ വാങ്ങലുകളുമായി ബന്ധപ്പെട്ട എല്ലാ നികുതികളും നിങ്ങളുടെ ഉത്തരവാദിതയാണ്, നമ്മുടെ നെറ്റ് വരുമാനത്തെ അടിസ്ഥാനമാക്കിയുള്ള നികുതികൾ ഒഴികെ, അതിനായി നമ്മൾ നിങ്ങളോട് ഇൻവോയിസ് അയയ്‌ക്കും. അത്തരം നികുതികളെ ഉടൻ പണമടയ്‌ക്കുകയും നമുക്ക് നിയമപരമായി സാധുവായ സ്വകാര്യភាព പ്രസ്താവനകൾ നൽകുകയും അത്തരം ഡാറ്റയെ കൈകാര്യം ചെയ്യുന്നതിന് ആവശ്യമായ സംവദ്ദങ്ങൾ നേടുകയും ചെയ്യുമെന്ന് നിങ്ങൾ സമ്മതിക്കുന്നു, കൂടാതെ പ്രയോഗികനായ നിയമങ്ങൾക്ക് അനുസൃതമായി നിങ്ങൾ അത്തരം ഡാറ്റയെ കൈകാര്യം ചെയ്യുന്നുവെന്ന് നിങ്ങൾ നമ്മോട് ഉറപ്പ് നൽകുന്നു.',
    block12:
      '(c) വില മാറ്റങ്ങൾ. നിങ്ങളുടെ അക്കൗണ്ടിലൂടെയും/അല്ലെങ്കിൽ ഞങ്ങളുടെ വെബ്സൈറ്റിലൂടെയും നിങ്ങളെ അറിയിച്ചുകൊണ്ട് ഞങ്ങൾ നമ്മുടെ വിലകൾ മാറ്റலாம். വില വർദ്ധനകൾ പോസ്റ്റുചെയ്തതിന് തുടനെ പ്രवर്തന ചെയ്യും. മാറ്റത്തിന്റെ പ്രवर്തന തീയതിക്ക് ശേഷം നിങ്ങളുടെ അക്കൗണ്ടിനുള്ള ഫീസുകൾക്ക് ഏതെങ്കിലും വില മാറ്റങ്ങൾ ബാധകമാകും. ',
    block13:
      '(d) തർക്കങ്ങളും കാലഹരണമായ പേയ്‌മെന്റുകളും. ഏതെങ്കിലും ഫീസ് അല്ലെങ്കിൽ നികുതികൾക്ക് എതിർക്കാൻ നിങ്ങൾ ആഗ്രഹിക്കുന്നുവെങ്കിൽ, ഇൻവോയ്സ് തീയതിയുടെ മുപ്പത് (30) ദിവസത്തിനുള്ളിൽ contact@noam.tools ക்க് ബന്ധപ്പെടുക.',
    block14:
      '(എ) സൗജന്യ ഉപയോഗം. സൗജന്യ ക്രെഡിറ്റുകൾ ലഭിക്കുന്നതിനായി നിങ്ങൾക്ക് ഒന്നിലധികം അക്ക ou ണ്ടുകൾ സൃഷ്ടിക്കാൻ കഴിയില്ല. നിങ്ങൾ സൗജന്യ ക്രെഡിറ്റുകളെ നല്ല വിശ്വാസത്തോടെ ഉപയോഗിക്കുന്നില്ലെന്ന് ഞങ്ങൾ നിർണ്ണയിച്ചാൽ, ഞങ്ങൾക്ക് നിങ്ങൾക്ക് സ്റ്റാൻഡേർഡ ഫീസുകൾ ഈടാക്കാം അല്ലെങ്കിൽ സേവനത്തിലേക്കുള്ള ആക്സസ് നൽകുന്നത് നിർത്താം.',
    block15:
      '(എ) രഹസ്യസൂചനा. നോംയുടെ രഹസ്യ വിവരങ്ങൾക്ക് നിങ്ങൾക്ക് പ്രവേശനം ഉണ്ടായേക്കാം. സേവനം ഉപയോഗിക്കുന്നതിനായി ഈ നിബന്ധനകളുടെ കീഴിൽ അനുവദിച്ചതുപോലെ മാത്രം രഹസ്യ വിവരങ്ങൾ ഉപയോഗിക്കാവുന്നതാണ്. രഹസ്യ വിവരങ്ങൾ ഏതെങ്കിലും മൂന്നാമത്തെ പാർട്ടിക്ക് വെളിപ്പെടുത്തരുത്, കൂടാതെ നിങ്ങളുടെ സ്വന്തം സമാന രഹസ്യ വിവരങ്ങൾ സംരക്ഷിക്കുന്നതിനേക്കാൾ കുറവായ സംരക്ഷണം നൽകാതെ, കുറഞ്ഞത് വിവേകപൂർവ്വം ശ്രദ്ധിച്ച് രഹസ്യ വിവരങ്ങൾ സംരക്ഷിക്കണം. നോം দ्वारా രഹസ്യമായി നിർദ്ദേശിച്ചിരിക്കുന്ന അപ്പബ്ലിക് വിവരങ്ങളോ സാഹചര്യങ്ങളുടെ അടിസ്ഥാനത്തിൽ യുക്തിസഹമായി രഹസ്യമായി കണക്കാക്കപ്പെടേണ്ടതോ ആയിരുന്നാലും, സോഫ്റ്റ്‌വെയർ, വിശദാംശങ്ങൾ, മറ്റ് അപ്പബ്ലിക് ബിസിനസ്സ് വിവരങ്ങൾ എന്നിവ ഉൾപ്പെടെ രഹസ്യ വിവരങ്ങൾ ആണ്. ഇനിപ്പറയുന്ന വിവരങ്ങൾ രഹസ്യ വിവരങ്ങളിൽ ഉൾപ്പെടുന്നില്ല: (1) നിങ്ങളുടെ ഭാഗത്ത് കുറ്റമില്ലാതെ പൊതുവേ പblic് доступ ലഭിക്കുന്നു; (2) ഈ നിബന്ധനകളുടെ കീഴിൽ ഇത് സ്വീകരിക്കുന്നതിന് മുമ്പ് രഹസ്യ സ忠信്യതയുടെ ഏതെങ്കിലും ബാധ്യതയില്ലാതെ നിങ്ങളുടെ കൈവശത്തുണ്ടായിരുന്നു; (3) ഏതെങ്കിലും രഹസ്യ ബാധ്യതകളില്ലാതെ മൂന്നാമത്തെ പാർട്ടി നിങ്ങൾക്ക് നിയമപരമായി വെളിപ്പെടുത്തിയിരിക്കുന്നു; അല്ലെങ്കിൽ (4) രഹസ്യ വിവരങ്ങൾ ഉപയോഗിക്കാതെ നിങ്ങൾ സ്വതന്ത്രമായി വികസിപ്പിച്ചു. നിയമം, കോടതി, അല്ലെങ്കിൽ മറ്റ് സർക്കാർ ഉത്തരവ് ആവശ്യപ്പെടുന്നുവെങ്കിൽ രഹസ്യ വിവരങ്ങൾ വെളിപ്പെടുത്താം, എന്നാൽ നിങ്ങൾ നോമിന് യുക്തിസഹമായ രീതിയിൽ മുൻകാല എഴുത്തിലുള്ള അറിയിപ്പ് നൽകണം, കൂടാതെ സാധ്യമായ പരിധിക്ക് വെളിപ്പെടുത്തൽ വ്യാപ്തി പരിമിതപ്പെടുത്തുന്നതിന് ശ്രമിക്കണം, ഇതിൽ വെളിപ്പെടുത്തൽ അഭ്യർത്ഥനകൾക്കെതിരെ എതിർക്കുന്നതിന് ഞങ്ങളെ സഹായിക്കുന്നു എന്നിവ ഉൾപ്പെടുന്നു.',
    block16:
      '(b) സുരക്ഷ. സേവനത്തിലേക്കുള്ള പ്രവേശനത്തിനും ഉപയോഗത്തിനും സംരക്ഷണം നൽകാൻ നിങ്ങൾ സාධारणവും ഉചിതവുമായ നടപടികൾ നടപ്പിലാക്കണം. സേവനത്തിന്റെ ഉപയോഗവുമായി ബന്ധപ്പെട്ട ഏതെങ്കിലും ദുർബലതകളോ ലംഘനങ്ങളോ കണ്ടെത്തുകയാണെങ്കിൽ, നിങ്ങൾ ഉടൻ നോംと контактം എടുക്കുകയും ദുർബലത അല്ലെങ്കിൽ ലംഘനത്തിന്റെ വിശദാംശങ്ങൾ നൽകുകയും വേണം. ',
    block17:
      '(c) വ്യക്തിഗത ഡാറ്റയുടെ പ്രോസസ്സിംഗ്. വ്യക്തിഗത ഡാറ്റ പ്രോസസ്സ ചെയ്യാൻ നിങ്ങൾ സേവനം ഉപയോഗിക്കുന്നുവെങ്കിൽ, നിങ്ങൾക്ക് നിയമപരമായി മതിയായ സ്വകാര്യ സ്റ്റേറ്റ്മെന്റുകൾ നൽകുകയും അത്തരം ഡാറ്റ പ്രോസസ്സ ചെയ്യുന്നതിന് ആവശ്യമായ സമ്മതങ്ങൾ ലഭിക്കുകയും വേണം, കൂടാതെ പ്രയോഗികമായ നിയമങ്ങൾക്ക് അനുസൃതമായി നിങ്ങൾ അത്തരം ഡാറ്റ കൈകാര്യം ചെയ്യുന്നുവെന്ന് നിങ്ങൾ ഞങ്ങൾക്ക് ഉറപ്പ് നൽകുന്നു.',
    block18:
      '(a) അവസാനിപ്പിക്കൽ; സസ്പെൻഷൻ. ഈ നിബന്ധനകൾ സേവനത്തെ നിങ്ങൾ ആദ്യമായി ഉപയോഗിക്കുന്നത് മുതൽ പ്രാബല്യത്തിലായിരിക്കും და അവസാനിപ്പിക്കപ്പെടുന്നതുവരെ പ്രാബല്യത്തിലായിരിക്കും. സേവനത്തെയും ഉള്ളടക്കത്തെയും ഉപയോഗിക്കുന്നത് നിർത്തുക വഴി നിങ്ങൾക്ക് ഏത് കാരണത്താലും ഈ നിബന്ധനകൾക്ക് എപ്പോൾ든 അവസാനം നൽകാം. ഏത് കാരണത്താലും മുൻകാലത്തെ അറിയിപ്പോടെ ഞങ്ങൾക്ക് ഈ നിബന്ധനകൾ അവസാനിപ്പിക്കാം. നിങ്ങൾ വിഭാഗം 2 (ഉപയോഗ ആവശ്യകതകൾ), വിഭാഗം 5 (രഹസ്യസൂചകത, സുരക്ഷിതത്വം, ഡാറ്റാ സംരക്ഷണം), വിഭാഗം 8 (വिवാദ പരിഹാരം) അല്ലെങ്കിൽ വിഭാഗം 9 (പൊതുവായ നിബന്ധനകൾ) എന്നിവയിൽ ഗണ്യമായി ലംഘിച്ചാൽ, അല്ലെങ്കിൽ നമുക്ക് നിയന്ത്രിക്കാൻ കഴിയാത്ത ഏതെങ്കിലും തൃതീയ പാർട്ടി സാങ്കേതിക സപ്ലയറുമായുള്ള നമ്മുടെ ബന്ധം മാറിയാൽ, അല്ലെങ്കിൽ നിയമ അല്ലെങ്കിൽ സർക്കാർ അഭ്യർത്ഥനകൾക്ക് അനുസൃതമാകണമെങ്കിൽ, ഞങ്ങൾക്ക് നിങ്ങളെ അറിയിപ്പിച്ചുകൊണ്ട് ഈ നിബന്ധനകൾക്ക് ഉടനെ അവസാനം നൽകാം. നിങ്ങൾ ഈ നിബന്ധനകൾക്ക് അനുസൃതമാകാത്താൽ, അല്ലെങ്കിൽ നിങ്ങളുടെ ഉപയോഗം ഞങ്ങൾക്ക് അല്ലെങ്കിൽ ഏതെങ്കിലും തൃതീയ പാർട്ടിക്ക് സുരക്ഷാ അപകടസാധ്യത ഉണ്ടാക്കുകയാണെങ്കിൽ, അല്ലെങ്കിൽ നിങ്ങളുടെ ഉപയോഗം വഞ്ചനാപരമാണെന്ന് അല്ലെങ്കിൽ ഇത് ഞങ്ങളെ അല്ലെങ്കിൽ ഏതെങ്കിലും തൃതീയ പാർട്ടിയെ ബാധ്യതയ്ക്ക് വിധിക്കുകയും ചെയ്യുമെന്ന് ഞങ്ങൾ സംശയിക്കുകയാണെങ്കിൽ, ഞങ്ങൾക്ക് സേവനത്തിലേക്കുള്ള നിങ്ങളുടെ ആക്സസ് സസ്പെൻഡ് ചെയ്യാം.',
    block19:
      '(b) പ്ര热熔നത്തിന്റെ ഫലങ്ങൾ. പ്ര热熔നത്തിനുശേഷം, നിങ്ങൾ സേവനം ഉപയോഗിക്കുന്നത് നിർത്തുകയും ഞങ്ങളുടെ നിർദ്ദേശപ്രകാരം ഏതെങ്കിലും രഹസ്യ വിവരങ്ങൾ ഉടൻ മടങ്ങുകയോ നശിപ്പിക്കുകയോ ചെയ്യണം. സ്വാഭാവികമായി പ്ര热熔നത്തിന് അല്ലെങ്കിൽ മেয়াഡിന് ശേഷം നിലനിൽക്കേണ്ട ഈ നിബന്ധനകളുടെ വ്യവസ്ഥകൾ, സെക്ഷൻ 3 மற்றும் 5-9 ഉൾപ്പെടെ എന്നാൽ ഇതിൽ പരിമിതമല്ല, നിലനിൽക്കും. ',
    block2:
      'നോംസ് സേവനങ്ങൾ, അതിൽ ഉൾപ്പെടുന്നത് ഞങ്ങളുടെ അപ്ലിക്കേഷൻ പ്രോഗ്രാമിംഗ് ഇന്റർഫേസുകൾ, സോഫ്റ്റ്‌വെയർ, ടൂളുകൾ, ഡെവലപ്പർ സേവനങ്ങൾ, ഡാറ്റാ, ഡോക്യുമെന്റേഷൻ, വെബ്സൈറ്റ് എന്നിവ (കൂടെ "സേവനങ്ങൾ" എന്ന് വിളിക്കുന്നു) ഉപയോഗിക്കുന്നതിന് ഈ ഉപയോഗനിബന്ധനകൾ ബാധകമാണ്. ഞങ്ങളുടെ സേവനങ്ങൾ ഉപയോഗിക്കുന്നതിലൂടെ, നിങ്ങൾ ഈ നിബന്ധനകൾ പാലിക്കുന്നത് സമ്മതിക്കുന്നു. ഞങ്ങൾ എങ്ങനെ വ്യക്തിഗത വിവരങ്ങൾ ശേഖരിക്കുന്നു மற்றும் ഉപയോഗിക്കുന്നു എന്നത് ഞങ്ങളുടെ സ്വകാര്യതാ നയം വിശദീകരിക്കുന്നു.',
    block20:
      'പ്രതിരോധം. സേവനത്തിന്റെ നിങ്ങളുടെ ഉപയോഗം, നിങ്ങളുടെ ഉള്ളടക്കം, സേവനവുമായി ബന്ധപ്പെട്ട ഉൽപ്പന്നങ്ങളുടെയോ സേവനങ്ങളുടെയോ നിങ്ങളുടെ ഉപയോഗം, ഈ നിബന്ധനകളുടെ അല്ലെങ്കിൽ ബാധക നിയമത്തിന്റെ നിങ്ങളുടെ ലംഘനം ഉൾപ്പെടെ, നിങ്ങളുടെ സേവന ഉപയോഗത്തിൽ നിന്ന് ഉള്ളതോ与之相关തോ ആയ ഏതെങ്കിലും ക്ലെയിമുകൾ, നഷ്ടങ്ങൾ, ചെലവുകൾ (അറ്റോർണി ഫീസ് ഉൾപ്പെടെ) മുതൽ ഞങ്ങളെ, ഞങ്ങളുടെ അഫിലിയേറ്റുകളെ, ഞങ്ങളുടെ ഉദ്യോഗസ്ഥരെ ക则徐ുത്തി രക്ഷിക്കും. ',
    block21:
      '(b) ഒഴിവാക്കലുകൾ. സേവനം "അങ്ങനെ തന്നെ" നൽകുന്നു. നിയമം അനുവദിക്കുന്ന പരിധിവരെ, ഞങ്ങളും ഞങ്ങളുടെ അഫിലിയേറ്റുകളും ലൈസൻസർമാർ സേവനത്തെക്കുറിച്ച് ഏതെങ്കിലും തരത്തിലുള്ള പ്രതിനിധ്യങ്ങളോ വാറന്റികളോ നൽകുന്നില്ല, കൂടാതെ വ്യാപാരപരമായതിന്റെ വാറന്റി, ഒരു പ്രത്യേക ഉദ്ദേശ്യത്തിനുള്ള യോഗ്യത, സന്തോഷകരമായ ഗുണനിലവാരം, കപ്പിടലുകളില്ലാതിരിക്കൽ, ശാന്തമായ ആസ്വാദം, കൂടാതെ ഇടപാടുകളുടെ കോഴ്സ് അല്ലെങ്കിൽ വ്യാപാര ഉപയോഗത്തിൽ നിന്ന് ഉണ്ടാകുന്ന ഏതെങ്കിലും വാറന്റികളും നൽകുന്നില്ല. സേവനം തടസ്സില്ലാതെ, കൃത്യമായ അല്ലെങ്കിൽ പിശകുകളില്ലാതെ ആയിരിക്കുമെന്നോ, ഏതെങ്കിലും ഉള്ളടക്കം സുരക്ഷിതമായിരിക്കും അല്ലെങ്കിൽ നഷ്ടപ്പെടില്ല അല്ലെങ്കിൽ മാറ്റില്ലെന്നോ ഞങ്ങൾ വാറന്റി നൽകുന്നില്ല.',
    block22:
      '(c) ഉത്തരവാദിത്തത്തിന്റെ പരിമితി. നമുക്ക്, ഞങ്ങളുടെ അഫിലിയേറ്റുകൾക്കോ, ഞങ്ങളുടെ ലൈസൻസർസിനോ, അസംപ്രമാണ, ആസംഭാവിക, പ്രത്യേക, അനന്തര അല്ലെങ്കിൽ ശിക്ഷാരൂപമായ നാശനഷ്ടങ്ങൾക്ക് ഉത്തരവാദിത്തം വരുന്നില്ല, ഇതിൽ ലാഭ നഷ്ടം, പ്രസിദ്ധി നഷ്ടം, ഉപയോഗ നഷ്ടം, ഡാറ്റ നഷ്ടം അല്ലെങ്കിൽ മറ്റ് അല്ലാത്ത നഷ്ടങ്ങൾ ഉൾപ്പെടുന്നു, അത്തരം നാശനഷ്ടങ്ങളുടെ സാധ്യതയെക്കുറിച്ച് ഞങ്ങളെ അറിയിച്ചിട്ടുണ്ടെങ്കിലും പോലും. ഈ പതിപ്പുകൾക്ക് കീഴിൽ, നമ്മുടെ ആകെ ഉത്തരവാദിത്തം ക്ലെയിമിന് മുമ്പുള്ള പന്ത്രണ്ട് (12) മാസങ്ങളിൽ നിങ്ങൾ സേവനത്തിന് നൽകിയ ഫീസുകള അല്ലെങ്കിൽ ഒരു നൂറ് യുഎസ് ഡോളർ ($100) എന്നിവയിൽ ഏതാണ് വലുത് അതിനേക്കാൾ കൂടുതലായിരിക്കില്ല. ഈ വിഭാഗത്തിലെ പരിമിതികൾ ബാധക നിയമത്തിന് അനുവദിച്ചിട്ടുള്ള പരമാവധി പരിധിയിൽ ബാധകമാണ്.',
    block23:
      'ഉപയോഗ നിബന്ധനകൾ සහ സേവനങ്ങൾ ഉപയോഗിക്കുന്നത് യുണൈറ്റഡ് സ്റ്റേറ്റ്സിന്റെ നിയമങ്ങൾക്ക് കീഴിലാണ്, യു.എസ്. കൺഫ്ലിക്ട് ഓഫ് ലോക്സ് നിയമങ്ങൾ ഒഴികെ. ആപ്ലിക്കേഷൻ ഉപയോഗിക്കുന്നത് മറ്റ് പ്രാദേശിക, സ്റ്റേറ്റ്, ദേശീയ അല്ലെങ്കിൽ അന്താരാഷ്ട്ര നിയമങ്ങൾക്ക് വിധേയമാകാം. ഈ നിബന്ധനകളുമായി ബന്ധപ്പെട്ട ഏതെങ്കിലും നിയമ നടപടി അല്ലെങ്കിൽ കാര്യം യുണൈറ്റഡ് സ്റ്റേറ്റ്സിന്റെ കോടതികളിൽ മാത്രമേ കൊണ്ടുവരൂ, കൂടാതെ അത്തരം കോടതികളുടെ വ്യക്തിഗത അധികാരത്തിന് വിധേയമാകാൻ നിങ്ങൾ സമ്മതിക്കുന്നു.',
    block24:
      'പാർട്ടികളുടെ ബന്ധം. നോം සහ നിങ്ങൾ സ്വതന്ത്ര കോൺട്രാക്ടർമാരാണ്, മാത്രമല്ല മറ്റൊരു പാർട്ടിയുടെ മുൻകാല ലിഖിത സമ്മതമില്ലാതെ ഏതൊരു പാർട്ടിക്കും മറ്റൊരു പാർട്ടിയെ പ്രതിനിധീകരിക്കാനോ ബന്ധിപ്പിക്കാനോ മറ്റൊരു പാർട്ടിയുടെ ബാധ്യതകൾ ഏറ്റെടുക്കാനോ കഴിവില്ല.',
    block25:
      '(b) ബ്രാൻഡ് ഉപയോഗം. നമ്മുടെ മുമ്പ് എഴുത്തിലുള്ള സാക്ഷ്യം ഇല്ലാതെ നിങ്ങൾക്ക് നോം അല്ലെങ്കിൽ അതിന്റെ ഏതെങ്കിലും അഫിലിയേറ്റുകളുടെ പേര്, ലോഗോകൾ അല്ലെങ്കിൽ ട്രേഡ്മാർക്കുകൾ ഉപയോഗിക്കാൻ കഴിയില്ല.',
    block26:
      'ഈ നിബന്ധനകളിലെ ഏതെങ്കിലും വ്യവസ്ഥ ആലോചന ചെയ്തപ്പോൾ അസാധുവാണെന്നോ, കുറ്റകരമാണെന്നോ, നടപ്പിലാക്കാൻ കഴിയില്ലെന്നോ കണ്ടെത്തിയാൽ, ബാക്കി വ്യവസ്ഥകൾ പൂർണ്ണമായി പ്രवर്തനക്ഷമതയോടെയും ഫലപ്രദമായും തുടരും. ',
    block3:
      'നിങ്ങൾ 18 വയസ്സിന് താഴെയാണെങ്കിൽ, സേവനം ഉപയോഗിക്കുന്നതിന് നിങ്ങളുടെ മാതാപിതാക്കളുടെയോ നിയമപരമായ കസ്റ്റഡിയൻമാരുടെയോ അനുമതി ലഭിക്കണം. നിങ്ങൾ മറ്റൊരു വ്യക്തിയുടെ അല്ലെങ്കിൽ സ്ഥാപനത്തിന്റെ പ്രതിനിധിയായി സേവനം ഉപയോഗിക്കുന്നുവെങ്കിൽ, അവരുടെ പ്രതിനിധിയായി ഈ നിബന്ധനകൾ സ്വീകരിക്കാൻ നിങ്ങൾക്ക് അധികാരമുണ്ടായിരിക്കണം. അക്കൗണ്ട് രജിസ്റ്റർ ചെയ്യുന്നതിന് നിങ്ങൾ കൃത്യമായും പൂർണ്ണമായ വിവരങ്ങൾ നൽകണം. നിങ്ങളുടെ ഓർഗനൈസേഷന് പുറത്തുള്ള ആർക്കും നിങ്ങളുടെ ആക്സസ് ക്രെഡൻഷ്യലുകളോ അക്കൗണ്ടോ നൽകാൻ നിങ്ങൾക്ക് കഴിയില്ല, മேலும் നിങ്ങളുടെ ക്രെഡൻഷ്യലുകൾ ഉപയോഗിച്ച് നടത്തുന്ന എല്ലാ പ്രവർത്തനങ്ങൾക്കും നിങ്ങൾക്ക് ഉത്തരവാദിത്തം ഉണ്ട്.',
    block4:
      '(എ) സേവനത്തിന്റെ ഉപയോഗം. ഈ നിബന്ധനകളുടെ കീഴിൽ നിങ്ങൾക്ക് സേവനം ആക്സസ്സ് ചെയ്യാം, കൂടാതെ ഞങ്ങൾ നിങ്ങൾക്ക് സേവനം ഉപയോഗിക്കാനുള്ള ഒരു അസംപ്രധാന അവകാശം നൽകുന്നു. സേവനം ഉപയോഗിക്കുമ്പോൾ, നിങ്ങൾ ഈ നിബന്ധനകളും എല്ലാ ബാധക നിയമങ്ങളും പാലിക്കും. സേവനത്തിലെ എല്ലാ അവകാശങ്ങൾ, ശീർഷകങ്ങൾ, താൽപ്പര്യങ്ങൾ ഞങ്ങളും ഞങ്ങളുടെ അഫിലിയേറ്റുകളും കൈവശം വയ്ക്കുന്നു. ',
    block5:
      'ഫീഡ്‌ബാക്ക്. ഞങ്ങൾ ഫീഡ്‌ബാക്ക്, അഭിപ്രായങ്ങൾ, ആശയങ്ങൾ, നിർദ്ദേശങ്ങൾ及び മെച്ചപ്പെടുത്തലുകൾ സ്വാഗതം ചെയ്യുന്നു. നിങ്ങൾ അത്തരം ഏതെങ്കിലും ഉള്ളടക്കം നൽകಿದರೆ, ഞങ്ങൾ അതിനെ 어떠soever പരിമിതികളില്ലാതെ及び നിങ്ങൾക്ക് ഏതെങ്കിലും നഷ്ടപരിഹാരമില്ലാതെ ഉപയോഗിക്കാം.',
    block6:
      '(c) നിയന്ത്രണങ്ങൾ. നിങ്ങൾക്ക് കഴിയില്ല: (1) മറ്റുള്ളവരുടെ ഏതെങ്കിലും അവകാശങ്ങളെ ലംഘിക്കുന്ന, അസാധുവായി പിടിക്കുന്ന അല്ലെങ്കിൽ ലംഘിക്കുന്ന രീതിയിൽ സേവനം ഉപയോഗിക്കുക; (2) റിവേഴ്സ് എഞ്ചിനീയർ, ഡീകോമ്പൈൽ, ഡിസാസംബിൾ, വിവർത്തനം അല്ലെങ്കിൽ സേവന മോഡലുകളുടെ ഉറവിട കോഡ് അല്ലെങ്കിൽ അടിസ്ഥാന ഘടകങ്ങൾ, അൽഗോരിതങ്ങൾ, സിസ്റ്റങ്ങൾ എന്നിവ കണ്ടെത്താൻ ശ്രമിക്കുക (ലागુ നിയമങ്ങൾ ഇത്തരം നിയന്ത്രണങ്ങളെ നിരോധിച്ചിട്ടില്ലെങ്കിൽ); (3) നോംと മത്സരിക്കുന്ന മോഡലുകൾ വികസിപ്പിക്കുന്നതിനായി സേവനത്തിന്റെ ഔട്ട്പുട്ട് ഉപയോഗിക്കുക; (4) API വഴി അനുവദിച്ചില്ലെങ്കിൽ, സ്ക്രാപ്പിംഗ്, വെബ് ഹാർവസ്റ്റിംഗ് അല്ലെങ്കിൽ വെബ് ഡാറ്റാ എക്സ്ട്രാക്ഷൻ ഉൾപ്പെടെ ഏതെങ്കിലും യാന്ത്രിക അല്ലെങ്കിൽ പ്രോഗ്രാമിംഗ് രീതികൾ ഉപയോഗിച്ച് സേവനത്തിൽ നിന്ന് ഡാറ്റ അല്ലെങ്കിൽ ഔട്ട്പുട്ട് എക്സ്ട്രാക്റ്റ് ചെയ്യുക; (5) സേവനത്തിന്റെ ഔട്ട്പുട്ട് അത് അല്ലാത്തപ്പോൾ കൃത്രിമമായി ജനറേറ്റുചെയ്‌തതായി പ്രäsent് ചെയ്യുക, അല്ലെങ്കിൽ മറ്റೆ തരത്തിൽ ഞങ്ങളുടെ ഉപയോഗ നയങ്ങൾ ലംഘിക്കുക; (6) ഞങ്ങളുടെ മുൻകൂട്ടി സമ്മതമില്ലാതെ API കീകൾ വാങ്ങുക, വിൽക്കുക അല്ലെങ്കിൽ കൈമാറുക; അല്ലെങ്കിൽ (7) 13 വയസ്സിന് താഴെയുള്ള കുട്ടികളുടെ ഏതെങ്കിലും വ്യക്തിഗത വിവരങ്ങൾ അല്ലെങ്കിൽ ഡിജിറ്റൽ സമ്മതത്തിന്റെ ലागુ വയസ് ഞങ്ങൾക്ക് നൽകുക. ഞങ്ങളുടെ ഡോക്യുമെന്റേഷനിലെ ഏതെങ്കിലും നിരക്ക് പരിധികളും മറ്റ് ആവശ്യകതകളും നിങ്ങൾ പാലിക്കും. ',
    block7:
      '(d) തriðർഡ്-പാർട്ടി സേവനങ്ങൾ. സേവനവുമായി ബന്ധപ്പെട്ട ഏതെങ്കിലും തriðർഡ്-പാർട്ടി സോഫ്റ്റ്‌വെയർ, സേവനങ്ങൾ അല്ലെങ്കിൽ മറ്റ് ഉൽപ്പന്നങ്ങൾ അവയുടെ സ്വന്തം നിബന്ധനകളാൽ നിയന്ത്രിക്കപ്പെടുന്നു, കൂടാതെ തriðർഡ്-പാർട്ടി ഉൽപ്പന്നങ്ങൾക്ക് ഞങ്ങൾ ഉത്തരവാദിയല്ല. ',
    block8:
      '(എ) നിങ്ങളുടെ ഉള്ളടക്കം. നിങ്ങൾ സേവനത്തിന് ഇൻപുട്ട് ("ഇൻപുട്ട്") നൽകാം, കൂടാതെ ഇൻപുട്ടിനെ അടിസ്ഥാനമാക്കി ജനറേറ്റുചെയ്‌തും മടങ്ങിയും വന്നുള്ള ഔട്ട്പുട്ട് ("ഔട്ട്പുട്ട്") സ്വീകരിക്കാം (കൂടെ "ഉള്ളടക്കം" എന്ന് വിളിക്കുന്നു). പാർട്ടികൾക്കിടയിൽ, മാത്രമല്ല ബാധക നിയമങ്ങൾ അനുവദിക്കുന്ന പരിധിയിൽ, നിങ്ങൾ എല്ലാ ഇൻപുട്ടുകളുടെയും ഉടമസ്ഥനാണ്. നോം സേവനം നൽകുന്നതിനും പരിപാലിക്കുന്നതിനും, ബാധക നിയമങ്ങൾക്ക് വിധേയമാക്കുന്നതിനും, ഞങ്ങളുടെ നയങ്ങൾ നടപ്പിലാക്കുന്നതിനുമായി ഉള്ളടക്കം ഉപയോഗിക്കാം. നിങ്ങൾ ഉള്ളടക്കത്തിന് ഉത്തരവാദിയാണ്, അതിൽ അത് ബാധക നിയമങ്ങളോ ഈ നിബന്ധനകളോ ലംഘിക്കുന്നില്ലെന്ന് ഉറപ്പാക്കുന്നു.',
    block9:
      '(b) കൃത്യത. കൃത്രിമ ബുദ്ധിയും മെഷീൻ ലേണിംഗും വേഗത്തിൽ വികസിക്കുന്ന ഗവേഷണ മേഖലകളാണ്. കൂടുതൽ കൃത്യവും വിശ്വസനീയവും സുരക്ഷിതവും പ്രയോജനകരവുമായ സേവനം നൽകാൻ ഞങ്ങൾ നിരന്തരം ശ്രമിക്കുന്നു. മെഷീൻ ലേണിംഗിന്റെ സംഭാവനാ സ്വഭാവം കണക്കിലെടുത്താൽ, ഞങ്ങളുടെ സേവനം ഉപയോഗിക്കുന്നത് ചില സന്ദർഭങ്ങളിൽ തെറ്റായ ഔട്ട്പുട്ടുകളുണ്ടാകാം, ഇത് യഥാർത്ഥ വ്യക്തികളെയോ സ്ഥലങ്ങളെയോ വസ്തുതകളെയോ കൃത്യമായി പ്രതിഫലിപ്പിക്കില്ല. നിങ്ങളുടെ ഉപയോഗ കേസിനെ അടിസ്ഥാനമാക്കി ഏതെങ്കിലും ഔട്ട്പുട്ടിന്റെ കൃത്യത വเหมาะമായി വിലയിരുത്തണം, അതിൽ മ anualി_outputs പരിശോധിക്കുന്നതും ഉൾപ്പെടുന്നു.',
    subTitle1: 'രജിസ്ട്രേഷൻ மற்றும் ആക്സസ്',
    subTitle10: 'വിഭജ്യാധികാരം',
    subTitle2: 'ഉപയോഗ ആവശ്യകതകൾ',
    subTitle3: 'കണ്ടന്റ്',
    subTitle4: 'ഫീസും പേയ്‌മെന്റും',
    subTitle5: 'ഗোপনത്വം, സുരക്ഷയും ഡാറ്റാ സംരക്ഷണവും',
    subTitle6: 'കാലാവധി மற்றும் അവസാനിപ്പിക്കൽ',
    subTitle7: 'പ്രതിബंधം; അവകാശവുമാറ്റങ്ങൾ; ബാധ്യതയുടെ പരിമിതി',
    subTitle8: 'ഭരണ നിയമവും അധികാര വ്യവസ്ഥയും',
    subTitle9: 'പൊതുവായ നിബന്ധനകൾ',
    title: 'സേവന നിബന്ധനകൾ',
    updateTime: 'പുതുക്കി തയ്യാറാക്കിയത്: മാർച്ച് 15, 2024',
  },
  trialModal: {
    btn: 'ഇപ്പോൾ ആരംഭിക്കുക（കೇವळ $0.99）',
    chat: 'ചാറ്റ് പിഡിഎഫ്',
    desc1: 'നിങ്ങളുടെ ട്രയൽ പൂർത്തിയാക്കിയ ശേഷം, വർഷാവരം $180 ഫീസ് ചാർജ് ചെയ്യും.‌',
    desc2: 'എപ്പോഴെങ്കിലും റദ്ദാക്കുക',
    focus: 'കേന്ദ്രീകരിക്കുക',
    hover: 'ഹോവർ വിവർത്തനം',
    image: 'ചിത്ര വിവർത്തനം',
    installBtn: 'ഇപ്പോൾ ഇൻസ്റ്റാൾ ചെയ്ത് നിങ്ങളുടെ സമ്മാനം ലഭിക്കുക',
    memo: 'പ്രിയപ്പെട്ട വസ്തുക്കളുടെ മാനേജ്മെന്റ്',
    pdf: 'PDF പ্যാരല lel ട്രാൻസ്ലേഷൻ',
    realtime: 'ഇൻസ്റ്റന്റ് വിവർത്തനം',
    select: 'വാക്ക് തിരഞ്ഞെടുക്കൽ വിവർത്തനം',
    title: 'സ്വാഗത സമ്മാനം',
    trialText: '7-ദിവസത്തെ പരീക്ഷണം',
    video: 'വീഡിയോ വിവർത്തനം',
    videoSummary: 'വീഡിയോ സംഗ്രഹം',
    web: 'പ্যറല lel വിവർത്തനം',
    webSummary: 'വെബ്സitesi സംഗ്രഹം',
  },
  upgradeModal: {
    btn: 'ഇപ്പോൾ അപ്‌ഗ്രേഡ് ചെയ്യുക',
    chat: {
      free: 'നിങ്ങൾ ChatPDF പരിധിയിൽ എത്തിച്ചേരেছেন',
      pro: 'ഈ മാസത്തെ ChatPDF പരിധി നിങ്ങൾ എത്തിച്ചിരിക്കുന്നു',
    },
    contactStr:
      'അടുത്ത റീസെറ്റിനായി കാത്തിരിക്കുക, അല്ലെങ്കിൽ contact@noam.tools എന്നതിലൂടെ ഞങ്ങളെ ബന്ധപ്പെടുക.',
    limitAlertStr: 'നിങ്ങളുടെ ഫ്രീ പ്ലാൻ പരിധി എത്തിച്ചു. തുടരണം 위해 അപ്‌ഗ്രേഡ് ചെയ്യുക.',
    more: 'പ്ലാനുകൾ കാണുക',
    pageLimit: { free: 'നിങ്ങൾ PDF പേജ് പരിധി എത്തിച്ചுள்ளீர்கள്' },
    title: 'റിമൈൻഡർ',
    upgradeAlertStr: 'നിങ്ങളുടെ ഫ്രീ പ്ലാൻ പരിധി എത്തിച്ചിരിക്കുന്നു. തുടരാൻ അപ്‌ഗ്രേഡ് ചെയ്യുക.',
    upload: {
      free: 'നിങ്ങളുടെ PDF വിവർത്തന പരിധി എത്തിച്ചിരിക്കുന്നു',
      pro: 'ഈ മാസത്തെ നിങ്ങളുടെ PDF വിവർത്തന പരിധി എത്തിച്ചിരിക്കുന്നു',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'ഇപ്പോൾ ചേരുക',
      label: 'പുതിയ ഉപയോക്തൃ ഗുണങ്ങൾ:',
      remain: 'കൂടുതൽ 30 മാത്രമേ ബാക്കിയുള്ളൂ',
      text: 'കेवळ 100 സ്പോട്ടുകൾ ലഭ്യമാണ്! ഇപ്പോൾ തന്റെ ഒന്ന് പിടിക്കുക!',
    },
  },
  aiPdfTranslator: {
    title:
      'ഉచిత എഐ പിഡിഎഫ് ട്രാൻസ്ലേറ്റർ: ഏതെങ്കിലും ഭാഷകളിൽ താരതമ്യം ഉപയോഗിച്ച് പിഡിഎഫ് വിവർത്തനം ചെയ്യുക',
    desc: 'AI ഉപയോഗിച്ച് PDF ഫയലുകളെ എളുപ്പത്തിൽ ഏത് ഭാഷയിലേക്കും വിവർത്തനം ചെയ്യുക. ഒറിജിനൽ மற்றும் വിവർത്തനം ചെയ്ത വാചകങ്ങൾ വേഗത്തിലും സൗജന്യമായി വശം വശമായി താരതമ്യം ചെയ്യുക.',
    keywords: 'GPT-4, AI അസിസ്റ്റന്‍റ്, വിവർത്തനം, സംഗ്രഹം, ഫോക്കസ്, ChatPDF, മെമോ, കാര്യക്ഷമത',
    sourceToTarget: {
      title:
        'ഫ്രീ PDF ട്രാൻസ്ലേഷൻ ടൂൾ: {{source}} നെ {{target}} ലേക്ക് സൗജന്യമായി വിവർത്തനം ചെയ്യുക',
      desc: 'നിങ്ങളുടെ PDF ഫയലുകളെ സൗജന്യമായി ഏതെങ്കിലും സ്രോതസ് ഭാഷയിൽ നിന്ന് നിങ്ങളുടെ പ്രിയപ്പെട്ട ഭാഷയിലേക്ക് വിവർത്തനം ചെയ്യുക. അഡ്വാൻസ്ഡ് AI ന്റെ പിന്തുണയോടുകൂടിയ വേഗതയുള്ള, കൃത്യമായ மற்றும் സുരക്ഷിതമായ PDF വിവർത്തനം.',
    },
    headerIntroduce: {
      title: 'നോം: ഓൺലൈൻ വിവർത്തനത്തിനപ്പുറമെ കൂടുതലും',
      introduce1: {
        title: 'നോം · പിഡിഎഫ് റീഡർ',
        desc: '✨സൈഡ്-ബൈ-സൈഡ് വിവർത്തനം + AI Q&A. പിഡിഎഫുകളെ നിങ്ങളുടെ ലക്ഷ്യ ഭാഷയിലേക്ക് വേഗത്തിലും കൃത്യമായും വിവർത്തനം ചെയ്യുക. പിഡിഎഫ ഫയലുകളെക്കുറിച്ച് ആഴത്തിലുള്ള ധാരണ നേടാൻ ഉള്ളടക്കത്തെക്കുറിച്ച് സ്വതന്ത്രമായി ചോദിക്കുക.',
      },
      introduce2: {
        title: 'നോം · സൈഡ്-ബൈ-സൈഡ് ട്രാൻസ്ലേഷൻ എക്സ്റ്റൻഷൻ',
        desc: '👏നിങ്ങളുടെ എല്ലാ വെബ്‌പേജ് വിവർത്തന ആവശ്യങ്ങളും പരിഹരിക്കുക:',
        detail1: { title: 'വെബ്‌പേജ് വിവർത്തനം:', desc: 'സൈഡ്-ബൈ-സൈഡ് ദ്വിഭാഷാ കാഴ്ച' },
        detail2: { title: 'വേഡ് വിവർത്തനം:', desc: 'ഒരു ക്ലിക്ക് വേഗ തർജ്ജമ' },
        detail3: {
          title: 'ഇൻസ്റ്റന്റ് വിവർത്തനം:',
          desc: 'പദങ്ങളോ വാക്യങ്ങളോ തൽക്ഷണം വിവർത്തനം ചെയ്യുക.',
        },
        detail4: { title: 'ചിത്ര വിവർത്തനം:', desc: 'ചിത്രങ്ങളെ വിവർത്തനം ചെയ്തതുമായി മാറ്റുക.' },
        detail5: {
          title: 'വീഡിയോ വിവർത്തനം:',
          desc: 'ച უკമായ കാണൽ അനുഭവത്തിനായി ദ്വിഭാഷാ സബ്ടൈറ്റിലുകൾ.',
        },
        footer: 'സ്മാർട്ടർ വിവർത്തനത്തിനായി കൂടുതൽ AI-സഹായിത വായനാ സവിശേഷതകൾ അനുഭവിക്കുക!',
      },
    },
    subtitle: 'PDF ഓൺലൈൻ തർജ്ജമ ചെയ്യുക സൗജന്യം',
    introduce: {
      module1: {
        detail1: {
          title: 'റിയൽ-ടൈം സൈഡ്-ബൈ-സൈഡ് പിഡിഎഫ് വിവർത്തനം',
          desc1:
            'ഒരു സമന്വയിപ്പിച്ച, വശങ്ങളിലുള്ള ലേയൗട്ടിൽ ഒറിജിനൽ மற்றும் വിവർത്തനത്തിലുള്ള ഉള്ളടക്കം உடனടി പ്രദർശിപ്പിക്കുക',
          desc2:
            'സിന്ക്രോണൈസ്ഡ് സ്ക്രോളിംഗ് ഉപയോഗിച്ച് രണ്ട് പതിപ്പുകളും എളുപ്പത്തിൽ താരതമ്യം ചെയ്യുക',
          desc3: 'സ്ഥിരമായ വായന അനുഭവത്തിനായി സമാന ഫോർമാറ്റിംഗ് നിലനിർത്തുക',
        },
        detail2: {
          title: 'സચોચിത ഉള്ളടക്ക സന്തുലനവും സ്ഥിരീകരണവും',
          desc1:
            'എളുപ്പമായി സ്ഥിരീകരിക്കുന്നതിനായി ഉറവിടവും വിവർത്തന വാചകവും തമ്മിലുള്ള കൃത്യമായ സംയോജനം',
          desc2: 'രണ്ട് പതിപ്പുകളിലും ഉള്ളടക്കത്തിന്റെ ഓരോ ഭാഗവും കൃത്യമായി പൊരുത്തപ്പെടുന്നു',
          desc3: 'വിശ്വസനീയ ഫലങ്ങൾക്കായി വിവർത്തന വ്യത്യാസങ്ങൾ വേഗത്തിൽ കണ്ടെത്തി പരിഹരിക്കുക',
        },
      },
      module2: {
        detail1: {
          title: 'കൃത്യമായ വിവർത്തനത്തിനുള്ള ഒന്നിലധികം അഡ്വാൻസ്ഡ് എഐ മോഡലുകൾ',
          desc1:
            'നിങ്ങളുടെ വിവർത്തന ആവശ്യങ്ങൾക്ക് പൊരുത്തപ്പെടുന്നതിനായി മുന്നോട്ടുള്ള AI മോഡലുകളിൽ നിന്ന് തിരഞ്ഞെടുക്കുക',
          desc2: 'വിവിധ രേഖ തരങ്ങൾക്കും വ്യവസായങ്ങൾക്കും ഒപ്റ്റിമൽ ഫലങ്ങൾ ഉറപ്പാക്കുക',
          desc3: 'യുക്തിഗത മോഡൽ ഓപ്ഷനുകൾ ഓരോ സാഹചര്യത്തിനും ഇടതൂക്കം കൽപ്പിച്ച പരിഹാരങ്ങൾ നൽകുന്നു',
        },
        detail2: {
          title: 'എല്ലാ കോണ്ടെന്റ് തരങ്ങൾക്കും വിപുലമായ AI വിവർത്തനം',
          desc1:
            'ഞങ്ങളുടെ ശക്തമായ AI മോഡൽ ഉയർന്ന കൃത്യതയും സ്വാഭാവിക ഭാഷാ മനസ്സിലാക്കലും ഉറപ്പാക്കുന്നു',
          desc2:
            'ടെക്നിക്കൽ, അക്കാദമിക്ക്, ക്രിയേറ്റീവ് ഡോക്യുമെന്റുകളെ എളുപ്പത്തിൽ കൈകാര്യം ചെയ്യുന്നു',
          desc3: 'നിങ്ങളുടെ എല്ലാ വിവർത്തന ആവശ്യങ്ങൾക്കും വിശ്വസനീയ ഫലങ്ങൾ നൽകുന്നു',
          desc4:
            'ഏറ്റവും മികച്ച പ്രകടനത്തിനായി വിവിധ ഉള്ളടക്ക തരങ്ങൾക്ക് ബുദ്ധിമാനانهായി പൊരുത്തപ്പെടൽ',
        },
      },
      module3: {
        detail1: {
          title: 'ബുദ്ധിമാനായ രേഖ പ്രതിപ്രവർത്തനം',
          desc1:
            'അഡ്വാൻസ്ഡ് എ.ഐ ഉപയോഗിച്ച് നിങ്ങളുടെ പിഡിഎഫ്, പ്രസെന്റേഷൻ ഫയലുകളുമായി ക്ഷമയായി ചാറ്റ് ചെയ്യുക',
          desc2:
            'Document കöntെന്റിനെക്കുറിച്ച് ഉടൻ തന്നെ ചോദിക്കുകയും കൃത്യമായ ഉത്തരങ്ങൾ ലഭിക്കുകയും ചെയ്യുക',
          desc3: 'ദീർഘ പ്രമാണങ്ങൾക്ക് വേഗത്തിൽ സംക്ഷिप്ത സംഗ്രഹങ്ങൾ സൃഷ്ടിക്കുക',
        },
        detail2: {
          title: 'ഗہന ഉള്ളടക്ക വിശകലനവും സീമ്ലെസ് ഇന്റഗ്രേഷനും',
          desc1:
            'എ Artificial Intelligence-പ്രചാരിതമായ മനസ്സിനോടെ പ്രധാന വിവരങ്ങൾ വേർതിരിച്ചെടുക്കുകയും സങ്കീർണ്ണ ഡാറ്റ വിശകലനം ചെയ്യുകയും ചെയ്യുക',
          desc2:
            'ടെക്നിക്കൽ, അക്കാദമിക് അല്ലെങ്കിൽ സ്രജനാത്മക മെറ്റീരിയലുകളിലേക്ക് ഉൾക്കാഴ്ച നേടുക',
          desc3:
            'പൂർണ്ണമായ ഡോക്യുമെന്റ് മാനേജ്മെന്റ് സൊല്യൂഷനായി ഞങ്ങളുടെ PDF ട്രാൻസ്ലേറ്ററുമായി സുഗമമായി സംയോജിപ്പിക്കുന്നു',
        },
      },
      module4: {
        detail1: {
          title: 'PDF വിവർത്തനത്തിനപ്പുറം: ഒറ്റത്തിൽ എല്ലാം ഉള്ള വെബ്‌പേജ് വിവർത്തന പരിഹാരം',
          desc: 'എല്ലാ ഓൺലൈൻ വായനാ സാഹചര്യങ്ങൾക്കായി രൂപകൽപ്പന ചെയ്ത ശക്തമായ സൈഡ്-ബൈ-സൈഡ് വിവർത്തന എക്സ്റ്റൻഷന שלנו കണ്ടെത്തുക.',
          desc1:
            'വെബ്‌പേജ് വിവർത്തനം: സമന്വയിച്ച സൈഡ്-ബൈ-സൈഡ് കാഴ്ചയോടുകൂടി ദ്വിഭാഷാ ഉള്ളടക്കം ആസ്വദിക്കുക',
          desc2: 'വേർഡ് ട്രാൻസ്ലേഷൻ: ഒരു ക്ലിക്കിൽ ഹൈലൈറ്റ് ചെയ്ത വാക്കുകൾ ഉടനടി വിവർത്തനം ചെയ്യുക',
          desc3:
            'ഇൻസ്റ്റന്റ് വിവർത്തനം: വേഗം മനസ്സിലാക്കാൻ ഏതെങ്കിലും പाठോ അല്ലെങ്കിൽ വാക്യം തത്കാലം വിവർത്തനം ചെയ്യുക',
          desc4: 'ചിത്ര വിവർത്തനം: യഥാർത്ഥ ചിത്രങ്ങളെ സ്വയമേവ വിവർത്തനം ചെയ്ത പതിപ്പുകള로 മാറ്റുക',
          desc5: 'വീഡിയോ വിവർത്തനം: മెరkezമായ അനുഭവത്തിനായി ദ്വിഭാഷാ സബ്ടൈറ്റിലുള്ള വീഡിയോകൾ കാണുക',
        },
      },
    },
    question: {
      title: 'പതിവായി ചോദിക്കുന്ന ചോദ്യങ്ങൾ',
      answer1: {
        title: 'പിഡിഎഫ് വിവർത്തനത്തിനായി നോം പിഡിഎഫ് ട്രാൻസ്ലേറ്റർ സൗജന്യമായി ഉപയോഗിക്കാമോ?',
        content:
          'അതെ, Sider PDF ട്രാൻസ്ലേറ്റർ ഉപയോഗിച്ച് നിങ്ങൾക്ക് PDFs ഫ്രീയായി വിവർത്തനം ചെയ്യാം! ഞങ്ങൾ 5,000 ടോക്കനുകളുടെ ഫ്രീ ക്വോട്ട നൽകുന്നു, ഇത് മാർക്കറ്റിൽ സാധാരണയായി കാണപ്പെടുന്ന മിക്ക PDF ഡോക്യുമെന്റുകളും വിവർത്തനം ചെയ്യാൻ പര്യാപ്തമാണ്. വലിയ ഫയലുകൾ വിവർത്തനം ചെയ്യേണ്ടതുണ്ടെങ്കിൽ അല്ലെങ്കിൽ അഡ്വാൻസ്ഡ സവിശേഷതകൾ ആവശ്യമാണെങ്കിൽ, കൂടുതൽ കഴിവുകൾക്കായി നമ്മുടെ പ്രീമിയം പ്ലാനുകളിലേക്ക് അപ്‌ഗ്രേഡ് ചെയ്യാൻ നിങ്ങൾക്ക് തിരഞ്ഞെടുക്കാം.',
      },
      answer2: {
        title: 'നോം പിഡിഎഫ് ട്രാൻസ്ലേറ്റർ എത്രത്തോളം കൃത്യമാണ്?',
        content:
          'നോം പിഡിഎഫ് ട്രാൻസ്ലേറ്റർ നിർദ്ദിഷ്ട അഡ്വാൻസ്ഡ് എഐ ടെക്നോളജി ഉപയോഗിച്ച് ਅਤੇ നിങ്ങളുടെ ഡോക്യുമെന്റുകളുടെ പശ്ചാത്തലം വളരെ കൃത്യമായി മനസ്സിലാക്കി ഉയർന്ന കൃത്യതയുള്ള വിവർത്തനങ്ങൾ നൽകുന്നു. ഏതൊരു യാന്ത്രിക വിവർത്തനവും പൂർണ്ണമായതല്ലെങ്കിലും, ഞങ്ങളുടെ സൈഡ്-ബൈ-സൈഡ് ഡിസ്പ്ലേ ഇഷ്ടപ്പെട്ട വിവർത്തനങ്ങൾ എളുപ്പത്തിൽ പരിശോധിക്കാനും ശരിയാക്കാനും അനുവദിക്കുന്നു, അന്തിമ ഫലം നിങ്ങളുടെ ഗുണനിലവാര പ്രതീക്ഷകളെ പാലിക്കുന്നുവെന്ന് ഉറപ്പുനൽകുന്നു. നോമുമായി വിശ്വസനീയവും കൃത്യമായും പിഡിഎഫ് വിവർത്തനം അനുഭവിക്കുക.',
      },
      answer3: {
        title: 'സ്കാന്‍ ചെയ്ത പിഡിഎഫുകള്‍ തര്‍ജമ ചെയ്യാമോ?',
        content:
          'അതെ, നമ്മുടെ ബിൽറ്റ്-ഇൻ OCR (ഓപ്റ്റിക്കൽ ക്യാരക്ടർ റിക്കോഗ്നിഷൻ) സാങ്കേതികത ഉപയോഗിച്ച് സ്കാൻ ചെയ്ത പിഡിഎഫുകളെ നിങ്ങൾക്ക് വിവർത്തനം ചെയ്യാം. നമ്മുടെ സിസ്റ്റം സ്കാൻ ചെയ്ത രേഖകളിലൂടെയും ഇമേജ്-ബേസ്ഡ് പിഡിഎഫുകളിലൂടെയും ടെക്സ്റ്റ് സ്വയമേവ എക്സ്ട്രാക്റ്റ് ചെയ്യുകയും തുടർന്ന് ഉള്ളടക്കത്തിന് വിവർത്തനം നൽകുകയും ചെയ്യുന്നു. ഇത് എഡിറ്റ് ചെയ്യാൻ കഴിയാത്ത അല്ലെങ്കിൽ ഇമേജ് മാത്രമുള്ള പിഡിഎഫുകളും കൃത്യമായി വിവർത്തനം ചെയ്യാൻ സാധിക്കുന്നുവെന്ന് ഉറപ്പുനൽകുന്നു.',
      },
      answer4: {
        title: 'വിവർത്തനത്തിന് എത്ര സമയമെടുക്കും?',
        content:
          'ഉല്പത്തി വേഗതയും കാര്യക്ഷമതയുമുള്ളതാണ്—മിക്ക ഡോക്യുമെന്റുകളും അവയുടെ നീളവും സങ്കീർണതയും അനുസരിച്ച് സെക്കന്റുകളിൽ നിന്ന് കുറച്ച് മിനിറ്റുകളിലേക്ക് പ്രോസസ്സ് ചെയ്യబడత്തాయి. ഉദാഹരണത്തിന്, ഒരു സ്റ്റാൻഡേർഡ് 10-പേജ് PDF ലേക്ക് വിവർത്തനം ചെയ്യുന്നതിന് സാധാരണയായി 2 മിനിറ്റിന് കുറവ് സമയമെടുക്കും. നിങ്ങളുടെ എല്ലാ ഡോക്യുമെന്റ് വിവർത്തന ആവശ്യങ്ങൾക്കും വേഗത്തിലുള്ള ടേണ്ട്-അറOUND് സമയങ്ങൾ ആസ്വദിക്കുക! ',
      },
      answer5: {
        title: 'വായനയ്ക്കായി സൈഡ്-ബൈ-സൈഡ് വ്യൂ നിർത്താം കൊണ്ട്?',
        content:
          'അതെ, നിങ്ങളുടെ പ്രമാണങ്ങൾ എപ്പോഴും സൈഡ്-ബൈ-സൈഡ് വായിക്കാൻ കഴിയും. ഈ ലെയเอაუთ് യഥാർത്ഥത്തിന്റെയും വിവർത്തനത്തിന്റെയും ഉള്ളടക്കം എളുപ്പത്തിൽ താരതമ്യം ചെയ്യാൻ നിങ്ങളെ അനുവദിക്കുന്നു, ഇത് സുഗമവും കാര്യക്ഷമവുമായ വായന അനുഭവത്തെ ഉറപ്പാക്കുന്നു. ',
      },
    },
    freeTrial: 'നिःಶुल್ಕ പരീക്ഷണം',
    toLanguage: { title: 'PDF AI വിവർത്തന ജോഡികൾ', item: '{{source}} മുതൽ {{target}}' },
  },
  aiPdfTranslate: {
    header: {
      features: 'വിശേഷതകൾ',
      blog: 'ബ്ലോഗ്',
      pricing: 'വിലനിർണ്ണയം',
      button: 'ഇപ്പോൾ വിവർത്തനം ചെയ്യുക',
      faq: 'അപേക്ഷിക്കപ്പെടുന്ന ചോദ്യങ്ങൾ',
    },
    hero: {
      upload: {
        title: 'നിങ്ങളുടെ PDF അപ്‌ലോഡുചെയ്യുക',
        highlight: 'ബ്രൌസ് ചെയ്യാൻ ക്ലിക്ക് ചെയ്യുക',
        max: 'മാക്സ്',
        desc: 'അല്ലെങ്കിൽ ഡ്രാഗ് & ഡ്രോപ് ചെയ്യുക',
      },
      to: 'ക്ക്',
      title: 'ഫ്രീ PDF ട്രാൻസ്ലേറ്റർ',
      pill: 'AI-സഹായിത പിഡിഎഫ് ട്രാൻസ്ലേറ്റർ',
      model: 'GPT-4 & ക്ലോഡ്',
      support: 'OCR പിന്തുണ',
      free: 'സൗജന്യ ട്രയൽ',
      translated: 'നോം tarafından വിവർത്തനം ചെയ്തത്',
      complete: 'അവലംബനം പൂർത്തിയായി',
      desc: 'മूल ലേഔട്ട് പ്രസ്‌തുതി ചെയ്യുന്ന തത്സമയ, കൃത്യമായ വിവർത്തനങ്ങൾ. നോം AI OCR និង സൈഡ്-ബൈ-സൈഡ് വ്യൂകളെ പിന്തുണയ്ക്കുന്നു.',
    },
    ticker: {
      pdf: 'പിഡിഎഫ് വിവർത്തനം',
      ocr: 'ഓസിആർ ടെക്നോളജി',
      format: 'ഫോർമാറ്റ് സംരക്ഷണം',
      multi: 'മൾട്ടി-ലാംഗ്വേജ്',
      side: 'പാർശ്വത്തോടെ',
      web: 'വെബ് വിവർത്തനം',
      chat: 'PDF ഉപയോഗിച്ച് ചാറ്റ് ചെയ്യുക',
      secure: 'സുരക്ഷിതവും സ്വകാര്യവും',
    },
    comparison: {
      bad: {
        title: 'സ്റ്റാൻഡേർഡ് വിവർത്തനം',
        head: 'ഫോർമാറ്റിംഗും പശ്ചാത്തലവും നഷ്ടപ്പെട്ടു',
        text1: 'പിശക്: ലെയ아웃് തകരાઈക്കുന്നു. ചിത്രങ്ങൾ സ്ഥാനം തെറ്റായിട്ടുണ്ട്.',
        text2:
          'ടെക്സ്റ്റ് ഒവർലാപ്പ് ആണ്, ഫോണ്ടുകൾ സ്ഥിരമല്ല. വായിക്കാൻ ബുദ്ധിമുട്ടുള്ളതും പ്രൊഫഷണൽ അല്ലാത്തതുമാണ്...',
      },
      dump: { title: 'പ്ലെയിൻ ടെക്സ്റ്റ് ഡമ്പ്' },
      good: {
        tag: 'മികച്ച ഫലം',
        title: 'നോം എയ് ഐ ട്രാൻസ്ലേഷൻ',
        sub: 'പرفെക്റ്റ് ഫോർമാറ്റിംഗ്, സന്ദർഭ സംബന്ധിത',
      },
      title: 'എന്തുകൊണ്ടാണ് നോം AI തിരഞ്ഞെടുക്കേണ്ടത്?',
      desc: 'കോപ്പി-പേസ്റ്റ് വിവർത്തനത്തിൽ കഷ്ടപ്പെടുന്നത് തുടരുക. സ്റ്റാൻഡേർഡ് ടൂളുകളും ഞങ്ങളുടെ AI-പവറ്റഡ് കോൺടെക്സ്റ്റ്-അവെയർ വിവർത്തനവും തമ്മിലുള്ള വ്യത്യാസം അനുഭവിക്കുക.',
    },
    showcase: {
      kicker: 'പിന്തുണയ്‌ക്കുന്ന രേഖകൾ',
      title2: 'ഏതെങ്കിലും ഭാഷ',
      title1: 'ഏതെങ്കിലും രേഖ',
      carousel1: 'കല',
      carousel2: 'വാസ്തുവിദ്യ',
      carousel4: 'ഔഷധം',
      carousel3: 'അക്കാദമിക് ജേണൽ',
      carousel5: 'ហិហ្វីណាន್ಸ',
      carousel6: 'നിയമം',
      note: 'തകനിക്, അക്കാദമിക്ക്, ക്രിയേറ്റീവ് ഡോക്യുമെന്റുകളെ എളുപ്പത്തിൽ കൈകാര്യം ചെയ്യുക.',
      carousel8: 'നയം',
      carousel7: 'കോൺട്രാക്ട്',
    },
    features: {
      big: {
        title: 'അഡ്വാൻസ്ഡ് എAI മോഡലുകൾ (GPT-4, ക്ലോഡ്)',
        desc: 'നിങ്ങളുടെ വിവർത്തന ആവശ്യങ്ങൾക്ക് അനുയോജ്യമായ മുൻനിർദ്ദിഷ്ട AI മോഡലുകളിൽ നിന്ന് തിരഞ്ഞെടുക്കുക. വിവിധ ഡോക്യുമെന്റ് തരങ്ങൾക്ക് ഒപ്റ്റിമൽ ഫലങ്ങൾ ഉറപ്പാക്കുക.',
      },
      grid1: {
        title: 'OCR പിന്തുണ',
        desc: 'സ്കാൻ ചെയ്‌ത പിഡിഎഫുകളിലും ഇമേജുകളിലുമുള്ള ടെക്സ്റ്റ് തൽക്ഷണം എക്സ്ട്രാക്റ്റ് ചെയ്ത് വിവർത്തനം ചെയ്യുക.',
      },
      grid2: {
        title: 'ഹൈ-റെസ് എക്സ്പോർട്ട്',
        desc: 'മੂല ലെയเอ奥特്തിനൊപ്പം PDF ഫോർമാറ്റിൽ നിങ്ങളുടെ വിവർത്തനം ചെയ്ത ഡോക്യുമെന്റുകൾ ഡൌൺലോഡ് ചെയ്യുക.',
      },
      grid3: {
        title: 'സൈഡ്-ബൈ-സൈഡ് താരതമ്യം',
        desc: 'മೂಲവും വിവർത്തന വാചകവും താരതമ്യം ചെയ്യുന്നതിനുള്ള സിന്ക്രണൈസ്ഡ് സ്ക്രോളിംഗ്.',
      },
      title1: 'ലിഖിത തർജമയേക്കാൾ കൂടുതൽ',
      line1: 'ടെക്നിക്കൽ പേപ്പർ.പിഡിഎഫ്',
      title2: 'ഇതൊരു വിപ്ലവമാണ്',
      line2: 'ഭാഷ കണ്ടെത്തുന്നു: ഇംഗ്ലീഷ്...',
      line3: 'മോഡൽ: GPT-4o (ഹൈ പ്രിസിഷൻ)',
      line4: 'അവലംബനം പൂർത്തിയായി (99% കൃത്യത)',
    },
    testimonials: {
      review1: {
        role: 'ഗവേഷകൻ',
        content:
          'അക്കാദമിക് പേപ്പറുകൾ വിവർത്തനം ചെയ്യുന്നതിൽ നോം AI എന്നെ മണിക്കൂറുകളോളം രക്ഷിച്ചു. സൈഡ്-ബൈ-സൈഡ് വ്യൂ ടെക്നിക്കൽ ടെർമുകൾ സ്ഥിരീകരിക്കുന്നതിന് വളരെ സഹായകരമാണ്.',
      },
      review2: {
        role: 'ഗ്ലോബൽ മാർക്കറ്റർ',
        content:
          'ഞാൻ ഉപയോഗിച്ചിട്ടുള്ള ഏറ്റവും മികച്ച PDF ട്രാൻസ്ലേറ്റർ. ഇത് യഥാർത്ഥ ഫോർമാറ്റിംഗ് പൂർണ്ണമായി സൂക്ഷിക്കുന്നു, ഇത് ഞങ്ങളുടെ മാർക്കറ്റിംഗ് ഡെക്കുകൾക്ക് വളരെ പ്രധാനമാണ്.',
      },
      review3: {
        role: 'പ്രമാണ നിയമ സलಹക്കാരൻ',
        content:
          'കൃത്യമായും വേഗതയും. കോൺട്രാക്റ്റ് വിവർത്തനങ്ങൾക്കും സ്കാന ചെയ്ത ഡോക്യുമെന്റുകളಿಗുള്ള OCR ഫീച്ചरും ഇത് തികച്ചും സുഗമമായി പ്രവർത്തിക്കുന്നതിനാൽ ഞാൻ ഇത് ഉപയോഗിക്കുന്നു.',
      },
      kicker: 'ഉപയോക്താക്കൾക്ക് ഇഷ്ടപ്പെടുന്നു',
      title: 'ഞങ്ങളുടെ ഉപയോക്താക്കൾ പറയുന്നത്',
    },
    cta: {
      title: 'ഭാഷാ തടസ്സങ്ങൾ തകർക്കാൻ തയ്യാറാണോ?',
      button: 'തിരുത്തലിനായി സ്വതന്ത്രമായി ആരംഭിക്കുക',
      desc: '10,000+ ഉപയോക്താക്കളുമായി ചേരുക და இன்றே നിങ്ങളുടെ ഡോക്യുമെന്റുകളை നോം AI ഉപയോഗിച്ച് വിവർത്തനം ചെയ്യാൻ ആരംഭിക്കുക.',
      hint: '',
    },
    languagePairs: {
      title: 'ഇംഗ്ലീഷ് പിഡിഎഫ് എഐ വിവർത്തന ജോഡികൾ',
      desc: 'നോം AI സപ്പോർട്ട് ചെയ്യുന്ന പ്രചാരപ്പെട്ട വിവർത്തന ദിശകൾ',
    },
    footer: {
      about: 'ഞങ്ങളെക്കുറിച്ച്',
      privacy: 'പ്രൈവസി പോളിസി',
      contact: 'സപ്പോർട്ടുമായി ബന്ധപ്പെടുക',
    },
  },
}

export default TRANSLATION
